import { LogObject, arkGradualRolloutEndedParams, arkGradualRolloutStartedParams, arkGradualRolloutStepChangedParams, arkNewProjectOnboardedParams, arkProjectOptedInParams, arkProjectOptedOutParams, arkSlackAlertSentParams, autofixPrMergedParams, autofixReportSentParams, buildEndParams, buildStartParams, chatGptWixAppActionSrc39Evid1609Params, ciPoliceDeadlineScheduleParams, ciPoliceMsTrackerButtonActionParams, ciPoliceMsTrackerOptOutDialogParams, ciPoliceMsTrackerOptOutDialogRulesAndProjectsParams, ciPoliceNumberOfTargetsParams, ciPoliceTicketPageLoadParams, ciPoliceTicketProjectButtonActionParams, ciPoliceTicketRuleButtonActionParams, createProjectParams, deadlineAlertParams, devibeAppCheckpointCreatedSrc196Evid6Params, devibeBlueprintVersionReadySrc196Evid4Params, devibeChatWidgetLoadedSrc196Evid8Params, devibeCodegenAgentSessionEndSrc196Evid201Params, devibeCodegenAgentSessionErrorSrc196Evid202Params, devibeCodegenAgentSessionStartSrc196Evid200Params, devibeEarlierAppCheckpointActionCompletedSrc196Evid7Params, devibeErrorPageShownSrc196Evid15Params, devibeErrorSrc196Evid5Params, devibeLandedOnWorksapceSrc196Evid13Params, devibePageFinishLoadingSrc196Evid3Params, devibePageStartLoadingSrc196Evid2Params, devibeUserClickSrc196Evid10Params, dpKbMcpServerCallSrc39Evid1996Params, emergencyOptOutDialogActionParams, executiveSummaryChangeTeamSrc11Evid3325Params, executiveSummaryCommitToDeadlineSrc11Evid3323Params, executiveSummaryCustomTimeRangeSrc11Evid3324Params, executiveSummaryEmailSentSrc11Evid3320Params, executiveSummaryEnterOverviewSrc11Evid3321Params, executiveSummaryMovingBetweenTabsSrc11Evid3322Params, fetchFallbackParams, fixButtonClickedParams, gitHubActionAiPrReviewWasCalledSrc11Evid15001Params, lokiRepoUpdateCreatedParams, lokiScheduleChangedParams, lokiUpdateMergedParams, lokiUpdatePrOpenedParams, lokiUpdatePrResultParams, lokiUpdateSkippedParams, panoramaAlertSentParams, panoramaAlertUserMarkParams, panoramaButtonActionParams, panoramaEnableDisableAlertsSrc11Evid104503Params, panoramaNewTransactionParams, panoramaPageVisitParams, panoramaSlackButtonActionParams, perferBundleResultParams, perferClickOnResetArtifactSBaselineButtonParams, perferMetricResultParams, perferReportOpenedParams, perferResetArtifactSBaselineParams, perferRunFinishedParams, perferRunResultParams, perferRunStartParams, perferTestCaseResultParams, perferTestEndedParams, perferTestResultParams, perferTestStartedParams, projectAddedToIgnoreListParams, projectPerformedEmergencyOptOutOfRuleParams, projectRemovedFromIgnoreListParams, projectResultReportedParams, reviewEnrichmentCompletedSrc11Evid15002Params, ruleBuildBreakingScheduledParams, ruleDryRunChangedParams, ruleResultReportedParams, ruleShouldSendAlertsToggledParams, ruleStatusChangedParams, sledMergeQueueManualClickSrc11Evid90599Params, sledMergeQueueRunSrc11Evid90600Params, startInitParams, viewPrButtonClickParams, violationsDeadlineSrc11Evid3319Params, weeklyReportButtonActionParams, weeklyStatusReportParams, wixCliActionParams, wixCliAppFlowAppCloudServerUploadedSrc11Evid5235Params, wixCliAppFlowAppGenerationAppGenerationEndParams, wixCliAppFlowAppGenerationExistingAppSelectedParams, wixCliAppFlowAppGenerationNewAppNameEnteredParams, wixCliAppFlowAppGenerationNewAppRegistrationEndParams, wixCliAppFlowAppGenerationTypeOfCreationSelectedParams, wixCliAppFlowAppTemplateSelectionsParams, wixCliAppFlowComponentInstalledInTheAppParams, wixCliAppFlowDevelopmentSiteAppInstallationOnDevelopmentSiteEndParams, wixCliAppFlowDevelopmentSiteAppInstallationOnDevelopmentSiteStartParams, wixCliAppFlowDevelopmentSiteDevelopmentSiteSetParams, wixCliAppFlowDevelopmentSiteExistingSiteSelectedParams, wixCliAppFlowDevelopmentSiteNewDevelopmentSiteCreationEndParams, wixCliAppFlowDevelopmentSiteNewDevelopmentSiteCreationStartParams, wixCliAppFlowDevelopmentSiteSiteSelectorAbortedParams, wixCliAppFlowDevelopmentSiteSiteSelectorOpenedParams, wixCliAppFlowDevelopmentSiteTypeOfDevelopmentSiteSelectedParams, wixCliAppFlowExtensionGenerationExtensionWasAddedParams, wixCliAppFlowFileUploadStartedParams, wixCliAppFlowStepsAnswersParams, wixCliAppFlowUploadEndedParams, wixCliAppFlowZipUploadDoneParams, wixCliAppsFlowDeploymentRequestSrc11Evid5234Params, wixCliAppsFlowDeploymentStatusSrc11Evid5232Params, wixCliAppsFlowTunnelCreationStatusSrc11Evid5233Params, wixCliCliCommandParams, wixCliCliCommandStatusParams, wixCliCliErrorParams, wixCliCliMessageDisplayedParams, wixCliCodeHasBeenChangedParams, wixCliFileFolderCreatedRenamedDeletedParams, wixCliLoginEndParams, wixCliLoginStartParams, wixCliReadyForReloadAfterCodeChangeParams, wixCliUserResponseToCliMessageParams, wixStandardsBotWeeklyAlertMessageButtonActionSrc11Evid3404Params, wixStandardsBotWeeklyAlertMessageWasSentSrc11Evid3402Params, wixStandardsBotWeeklyViolationAlertMessageWasSentSrc11Evid3403Params, wixStandardsEmergencyOptOutPopupMessageSrc11Evid3326Params, wixStandardsEndFalconRunTimeExperimentSrc11Evid33101Params, wixStandardsInitialExtensionWasAddedSrc11Evid3316Params, wixStandardsOptOutRequestsApplicationActionSrc11Evid3345Params, wixStandardsOptOutRequestsApplicationClickSrc11Evid3344Params, wixStandardsProjectWasRejectedAndNotAddedToTheIgnoreListSrc11Evid3332Params, wixStandardsStartFalconRunTimeExperimentSrc11Evid33100Params, wixStandardsTicketEmergencyOptOutDialogOpenSrc11Evid3633Params, yoshiCodeChangeDetectedParams, yoshiReadyForReloadAfterCodeChangeParams, yoshiTestsRunEndParams, yoshiTestsRunStartParams, yoshiYarnStartFinishedParams } from '../types';

/**
 * A function to create a log object for the 'panoramaNewTransaction' event (evid: 104401)
 *
 * Event description: Sent every time there is a new transaction in click house
 *
 * @param {panoramaNewTransactionParams} params - The parameters for this event
 * @property {string} result - The result of receiving different data (can be Added/Removed)
 * @property {string} componentId - The name of the component
 * @property {string} fullArtifactId - The full artifact name
 * @property {string} platform - The platform of the artifact
 * @property {string} transaction - The transaction type (can be component load/http request etc), if transaction is component load and result = new , this means a new was dashboard created)
 * @return {LogObject<panoramaNewTransactionParams>} LogObject<panoramaNewTransactionParams>
 */
export function panoramaNewTransaction(params: panoramaNewTransactionParams): LogObject<panoramaNewTransactionParams> {
  return { evid: 104401, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'panoramaAlertSent' event (evid: 104501)
 *
 * Event description: Sent every time Panorama sends a slack notification (or when sending fails)
 *
 * @param {panoramaAlertSentParams} params - The parameters for this event
 * @property {string} failedToSend - IF message has failed to send will contain the reason of failure else null
 * @property {string} slackId - The id of the slack message can use to connect between events (104501 & 104502)
 * @property {string} state - The state of the alert (can be ‘ok’/’alerting’)
 * @property {string} currentTimeInterval - duration string i.e. 5M
 * @property {number} alertingValue - The (problematic) value for which alert was fired
 * @property {string} messageStatus - The status of the slack message (sent/failed - {reason}/disabled - {details})
 * @property {GUID} alertId - Alert id (can be used to connect to event Alert Sent 105501)
 * @property {string} componentId - The name of the component
 * @property {string} alertMethod - This parameter marks how the alert was sent to the project owners. It can be by Opsgenie integration (if the owner uses Opsgenie) or else it will be sent through Slack directly (possible values: opsgenie or panorama-slack-bot). Alerts sent through Opsgenie will have slack_id = null.
 * @property {boolean} isExperimental - Marks whether the alert is sent from an experimental template for testing queries (i.e. this alert is not sent to users)
 * @property {string} fullArtifactId - The full artifact name
 * @property {number} affectedSessionsCount - The number of sessions affected when the alert  started (meaning state = 'alerting') or when alert was resolved (meaning alert = 'ok')
 * @property {string} alertType - Type of fired alert (currently ‘success rate’/duration’)
 * @property {number} threshold - The current threshold for the panel from which the alert was sent
 * @property {string} platform - The platform of the artifact
 * @property {number} throughput - The current traffic when the alert was fired
 * @property {string} transactionName - The transaction type (can be component load/http request etc)
 * @return {LogObject<panoramaAlertSentParams>} LogObject<panoramaAlertSentParams>
 */
export function panoramaAlertSent(params: panoramaAlertSentParams): LogObject<panoramaAlertSentParams> {
  return { evid: 104501, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'panoramaSlackButtonAction' event (evid: 104502)
 *
 * Event description: Sent every time a user clicks on one of the buttons in the slack message (can be connected to event 104501 using slack id)
 *
 * @param {panoramaSlackButtonActionParams} params - The parameters for this event
 * @property {string} slackId - The id of the slack message can use to connect between events (104501 & 104502)
 * @property {string} buttonAction - The button clicked by the user (currently - alerting graph/ investigation dashboard)
 * @property {GUID} alertId - Alert Id
 * @return {LogObject<panoramaSlackButtonActionParams>} LogObject<panoramaSlackButtonActionParams>
 */
export function panoramaSlackButtonAction(params: panoramaSlackButtonActionParams): LogObject<panoramaSlackButtonActionParams> {
  return { evid: 104502, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'panoramaEnableDisableAlertsSrc11Evid104503' event (evid: 104503)
 *
 * Event description: Sent per transaction every time a user enables/disables panorama alerts (If the state does not change, no event will be sent for the particular transaction)
 *
 * @param {panoramaEnableDisableAlertsSrc11Evid104503Params} params - The parameters for this event
 * @property {string} entityType - 'Artifact' / 'Component' / 'Transaction' depends on the level which the operation performed
 * @property {string} fullArtifactId - Artifact id
 * @property {string} componentId - Component id
 * @property {string} transactionName - Transaction name
 * @property {string} operation - 'Enable'/'Disable'
 * @property {string} userEmail - The user email (without the @wix.com) who executed the operation
 * @return {LogObject<panoramaEnableDisableAlertsSrc11Evid104503Params>} LogObject<panoramaEnableDisableAlertsSrc11Evid104503Params>
 */
export function panoramaEnableDisableAlertsSrc11Evid104503(params: panoramaEnableDisableAlertsSrc11Evid104503Params): LogObject<panoramaEnableDisableAlertsSrc11Evid104503Params> {
  return { evid: 104503, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'panoramaPageVisit' event (evid: 104601)
 *
 * Event description: Sent every time a user visits Panorama - breakdown or overview in dev portal
 *
 * @param {panoramaPageVisitParams} params - The parameters for this event
 * @property {GUID} alertId - alert id
 * @property {string} componentId - The name of the component (if the page visited is overview this field will be null)
 * @property {string} userEmail - The email of the user performing a visit
 * @property {string} anomalyType - Type of anomaly error (currently ‘success rate’/duration’)
 * @property {string} fullArtifactId - The full artifact name
 * @property {string} sessionId - A session id helping is to identify a users distinct visit
 * @property {string} alertType - Type of fired alert (currently ‘success rate’/duration’)
 * @property {string} pageName - The name of the page we're in (currently 'breakdown' or ' overview')
 * @property {string} transactionName - The transaction type (can be component load/http request etc) if the page visited is overview this field will be null
 * @return {LogObject<panoramaPageVisitParams>} LogObject<panoramaPageVisitParams>
 */
export function panoramaPageVisit(params: panoramaPageVisitParams): LogObject<panoramaPageVisitParams> {
  return { evid: 104601, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'panoramaButtonAction' event (evid: 104602)
 *
 * Event description: Sent every time a user clicks on one of the buttons in Panorama dev portal (can be connected to event 104601 using session id)
 *
 * @param {panoramaButtonActionParams} params - The parameters for this event
 * @property {string} userEmail - User email without "@wix.com"
 * @property {string} sessionId - A session id helping is to identify a users visit
 * @property {string} buttonClicked - The name of the section clicked
 * @property {string} action - The action committed (currently 'collapse'/ 'hide')
 * @return {LogObject<panoramaButtonActionParams>} LogObject<panoramaButtonActionParams>
 */
export function panoramaButtonAction(params: panoramaButtonActionParams): LogObject<panoramaButtonActionParams> {
  return { evid: 104602, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'panoramaAlertUserMark' event (evid: 105501)
 *
 * Event description: Sent when user markes alert as FalsePositive or TruePositive
 *
 * @param {panoramaAlertUserMarkParams} params - The parameters for this event
 * @property {GUID} alertId - Alert id (can be used to connect to event Alert Sent 104501)
 * @property {string} markedBy - User who marked the alert (without the @wix suffix)
 * @property {string} userMark - FalsePositive or TruePositive
 * @return {LogObject<panoramaAlertUserMarkParams>} LogObject<panoramaAlertUserMarkParams>
 */
export function panoramaAlertUserMark(params: panoramaAlertUserMarkParams): LogObject<panoramaAlertUserMarkParams> {
  return { evid: 105501, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowAppTemplateSelections' event (evid: 114003)
 *
 * Event description: The event will be sent when the user selects anything regarding templates - if he chooses to start from a template or scratch, which template he chooses.
 *
 * @param {wixCliAppFlowAppTemplateSelectionsParams} params - The parameters for this event
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @property {DateTime} localTime - The local time during which the command was entered
 * @property {string} projectId - The project that the users is currently working on
 * @property {string} question - Template or from scratch, which template
 * @property {string} answer - the user choice (template/from scratch, template guid)
 * @property {string} additionalInfo - Any additional info needed, at the which template question - template name
 * @return {LogObject<wixCliAppFlowAppTemplateSelectionsParams>} LogObject<wixCliAppFlowAppTemplateSelectionsParams>
 */
export function wixCliAppFlowAppTemplateSelections(params: wixCliAppFlowAppTemplateSelectionsParams): LogObject<wixCliAppFlowAppTemplateSelectionsParams> {
  return { evid: 114003, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'fetchFallback' event (evid: 114700)
 *
 * Event description: This event is sent when the navigator.sendBeacon() request failed to enqueue, in which case we fallback to a fetch() request.
 *
 * @param {fetchFallbackParams} params - The parameters for this event
 * @property {number} batchLength - The number of batch items
 * @property {number} batchSize - The size in bytes of the reported batch
 * @property {string} batchItems - Comma-separated serialized items
 * @property {GUID} sessionId - session_id
 * @property {string} platform - platform
 * @return {LogObject<fetchFallbackParams>} LogObject<fetchFallbackParams>
 */
export function fetchFallback(params: fetchFallbackParams): LogObject<fetchFallbackParams> {
  return { evid: 114700, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'gitHubActionAiPrReviewWasCalledSrc11Evid15001' event (evid: 15001)
 *
 * Event description: Git Hub Action - AI PR Review was called
 *
 * @param {gitHubActionAiPrReviewWasCalledSrc11Evid15001Params} params - The parameters for this event
 * @property {string} action_version - Version of the GitHub Action that produced the review
 *
 * @property {number} additions - Total lines added across all files in the PR
 * @property {number} comment_count - Number of inline review comments posted
 *
 * @property {DateTime} created_at - ISO-8601 timestamp of when the review was created
 *
 * @property {number} deletions - Total lines deleted across all files in the PR
 *
 * @property {number} duration_ms - Wall-clock time for the Codex agent call, in milliseconds
 *
 * @property {number} file_count - Number of files changed in the PR
 *
 * @property {string} head_sha - Commit SHA the review was posted against (HEAD at review time)
 *
 * @property {string} review_id - Review node_id from GitHub  globally unique per review
 *
 * @property {string} model - LLM model used for the review
 *
 * @property {string} pr_author - author
 *
 * @property {number} pr_number - PR number within the repository
 *
 * @property {string} pr_owner - GitHub owner (user or org) of the repository
 *
 * @property {string} pr_repo - Repository name
 *
 * @property {number} schema_version - Schema version for forward compatibility
 *
 * @property {string} trigger - What triggered this review. Values: mention, pr_opened
 *
 * @property {number} usage_input_tokens - Total input tokens from the LLM call
 *
 * @property {number} usage_cached_input_tokens - Cached input tokens from the LLM call
 *
 * @property {number} usage_output_tokens - Output tokens from the LLM call
 *
 * @return {LogObject<gitHubActionAiPrReviewWasCalledSrc11Evid15001Params>} LogObject<gitHubActionAiPrReviewWasCalledSrc11Evid15001Params>
 */
export function gitHubActionAiPrReviewWasCalledSrc11Evid15001(params: gitHubActionAiPrReviewWasCalledSrc11Evid15001Params): LogObject<gitHubActionAiPrReviewWasCalledSrc11Evid15001Params> {
  return { evid: 15001, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'reviewEnrichmentCompletedSrc11Evid15002' event (evid: 15002)
 *
 * Event description: Fires when an internal system completes the review enrichment process in ARK. The event captures the results of the enrichment for a pull request, including the model used and various metrics like suggestion acceptance rates and confidence levels.
 *
 * @param {reviewEnrichmentCompletedSrc11Evid15002Params} params - The parameters for this event
 * @property {string} acceptance_rate - Fraction of comments classified as accepted or partially accepted (0–1)
 *
 * @property {number} accepted_count - Number of comments fully accepted by the PR author
 *
 * @property {number} acknowledged_count - Number of comments acknowledged but not acted on
 *
 * @property {string} action_version - Version of the GitHub Action that produced the review
 *
 * @property {number} author_replied_count - Number of comments where the PR author replied in the thread
 *
 * @property {DateTime} closed_at - ISO-8601 timestamp of when the PR was closed or merged
 *
 * @property {string} enrichment_model - LLM model used for the enrichment analysis
 *
 * @property {string} head_sha_at_close - Commit SHA of HEAD when the PR was closed or merged
 *
 * @property {string} head_sha_at_review - Commit SHA of HEAD when the original review was posted
 *
 * @property {number} high_confidence_count - Number of comments classified with high confidence
 *
 * @property {number} ignored_count - Number of comments with no response or code change
 *
 * @property {number} low_confidence_count - Number of comments classified with low confidence
 *
 * @property {number} medium_confidence_count - Number of comments classified with medium confidence
 *
 * @property {boolean} is_merged - Whether the PR was merged (true) or closed without merging (false)
 *
 * @property {DateTime} merged_at - ISO-8601 timestamp of when the PR was merged, or null if closed unmerged
 *
 * @property {number} partially_accepted_count - Number of comments partially addressed by the PR author
 *
 * @property {string} pr_author - GitHub login of the PR author
 *
 * @property {number} pr_number - PR number within the repository
 *
 * @property {string} pr_owner - GitHub owner (user or org) of the repository
 *
 * @property {string} pr_repo - Repository name
 *
 * @property {number} region_modified_count - Number of comments whose code region was modified after the review
 *
 * @property {number} rejected_count - Number of comments explicitly rejected by the PR author
 *
 * @property {DateTime} review_created_at - ISO-8601 timestamp of when the original review was created
 *
 * @property {string} review_id - Globally unique node_id of the review being enriched
 *
 * @property {number} thread_resolved_count - Number of comment threads that were resolved
 *
 * @property {number} total_comments - Total number of review comments evaluated
 *
 * @property {number} total_thumbs_down - Total thumbs-down reactions across all comments
 *
 * @property {number} total_thumbs_up - Total thumbs-up reactions across all comments
 *
 * @property {number} usage_cached_input_tokens - Number of input tokens served from cache
 *
 * @property {number} usage_input_tokens - Number of input (prompt) tokens consumed
 *
 * @property {number} usage_output_tokens - Number of output (completion) tokens generated
 *
 * @return {LogObject<reviewEnrichmentCompletedSrc11Evid15002Params>} LogObject<reviewEnrichmentCompletedSrc11Evid15002Params>
 */
export function reviewEnrichmentCompletedSrc11Evid15002(params: reviewEnrichmentCompletedSrc11Evid15002Params): LogObject<reviewEnrichmentCompletedSrc11Evid15002Params> {
  return { evid: 15002, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'projectResultReported' event (evid: 3301)
 *
 * Event description: Sent when project results reported
 *
 * @param {projectResultReportedParams} params - The parameters for this event
 * @property {number} amount_failing - amount failing
 * @property {number} amount_passing - amount passing
 * @property {number} amount_warning - amount warning
 * @property {number} amount_disabled - amount disabled
 * @property {number} amountRegressedToWarning - How many rules passed in previous project build, and now get a warning. This number should be <= amount_warning.
 * @property {number} amountRegressedToFailing - How many rules passed or got a warning in previous project build, and now fail. This number should be <= amount_failing.
 * @property {number} amountIgnored - How many rules are ignored for this project
 * @property {string} project_name - project name
 * @return {LogObject<projectResultReportedParams>} LogObject<projectResultReportedParams>
 */
export function projectResultReported(params: projectResultReportedParams): LogObject<projectResultReportedParams> {
  return { evid: 3301, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'projectAddedToIgnoreList' event (evid: 3302)
 *
 * Event description: Sent every time a rule is added to ignore list for a specific project and specific violation (when it's relevant)
 *
 * @param {projectAddedToIgnoreListParams} params - The parameters for this event
 * @property {DateTime} expirationDate - If the project is TEMPORARILY opting out of the rule (= ignored), then this will be the end of the ignore period. Otherwise (indefinite ignore), then null.
 * @property {string} addedBy - Who added the project to ignore list
 * @property {boolean} isTemporary - TRUE if the project is opting out of the rule temporarily; FALSE otherwise (indefinite ignore).
 * @property {string} rule_name - rule name
 * @property {boolean} isExtend - TRUE if the opt out of the project for this rule is extension of a previous opt out, FALSE otherwise (new opt out)
 * @property {string} violationId - A violation id that indicated where in the code the violation was made
 * @property {string} project_name - project name
 * @property {string} applicationGroupId - the group id of the application
 * @property {string} applicationItemId - the item id of the application
 * @property {boolean} isQualityOwner - If the added_by value is the quality owner who accept the request for an extension so is_quality_owner gets True, otherwise False.
 * @return {LogObject<projectAddedToIgnoreListParams>} LogObject<projectAddedToIgnoreListParams>
 */
export function projectAddedToIgnoreList(params: projectAddedToIgnoreListParams): LogObject<projectAddedToIgnoreListParams> {
  return { evid: 3302, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'ruleDryRunChanged' event (evid: 3303)
 *
 * Event description: Sent when dry run status changed (dry run on = grace period)
 *
 * @param {ruleDryRunChangedParams} params - The parameters for this event
 * @property {string} toggleSource - "Rule Configuration"/"Scheduled Break"
 * @property {boolean} is_dry_run_on - new dry run status true - on, false - off
 * @property {string} rule_name - rule name
 * @return {LogObject<ruleDryRunChangedParams>} LogObject<ruleDryRunChangedParams>
 */
export function ruleDryRunChanged(params: ruleDryRunChangedParams): LogObject<ruleDryRunChangedParams> {
  return { evid: 3303, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'ruleResultReported' event (evid: 3304)
 *
 * Event description: Sent once a day with aggregated results for each rule
 *
 * @param {ruleResultReportedParams} params - The parameters for this event
 * @property {number} amount_opt_out_warning - amount of rules that opt out while warning
 * @property {number} amount_failing - amount failing
 * @property {number} amount_passing - amount passing
 * @property {number} amount_warning - amount warning
 * @property {number} amount_disabled - amount disabled
 * @property {string} ruleGroup - To which group does the rule belong: "Business Manager", "BI", "Core Services", "Contacts", "Mobile", "Sled", "Viewer", "General", ""Scoped migration", "CI", "Node Platform", "Design Systems", "Performance"
 * @property {string} runMode - The rule's run mode: production/development
 * @property {number} amount_opt_out_disabled - amount of rules that opt out while being disabled
 * @property {number} amount_opt_out_indefinitely - amount of rules that are opted out indefinitely
 * @property {string} rule_name - rule name
 * @property {number} amount_opt_out_failing - amount of rules that opt out while failing
 * @property {number} amount_opt_out_passing - amount of rules that opt out while passing
 * @return {LogObject<ruleResultReportedParams>} LogObject<ruleResultReportedParams>
 */
export function ruleResultReported(params: ruleResultReportedParams): LogObject<ruleResultReportedParams> {
  return { evid: 3304, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'projectRemovedFromIgnoreList' event (evid: 3306)
 *
 * Event description: Sent every time a rule is removed from ignore list for a specific project and specific violation (when it's relevant)
 *
 * @param {projectRemovedFromIgnoreListParams} params - The parameters for this event
 * @property {string} ruleName - From which rule's ignore list has the project been removed
 * @property {string} projectName - Which project has been removed from the ignore list
 * @property {string} removedBy - Who removed the project from ignore list. If it's an automatic removal (because the ignore period expired)
 * @property {string} violationId - A violation id that indicated where in the code the violation was made
 * @property {string} removeMethod - "manual" (from CI Police rule configuration)/"expired" (ignore period expired, so rules has been automatically removed from ignore list)
 * @return {LogObject<projectRemovedFromIgnoreListParams>} LogObject<projectRemovedFromIgnoreListParams>
 */
export function projectRemovedFromIgnoreList(params: projectRemovedFromIgnoreListParams): LogObject<projectRemovedFromIgnoreListParams> {
  return { evid: 3306, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'ruleShouldSendAlertsToggled' event (evid: 3307)
 *
 * Event description: Sent once a day per rule the rule's run mode (Dev to Prod or the other way around), which also affects the setting of sending alerts (either from False to True or the other way around)
 *
 * @param {ruleShouldSendAlertsToggledParams} params - The parameters for this event
 * @property {string} ruleName - Which rule is being toggled
 * @property {string} prevRunMode - The rule's PREVIOUS run mode: production/development
 * @property {string} newRunMode - The rule's NEW run mode: production/development
 * @property {boolean} shouldSendAlerts - TRUE if the user chose to send alerts, FALSE otherwise
 * @return {LogObject<ruleShouldSendAlertsToggledParams>} LogObject<ruleShouldSendAlertsToggledParams>
 */
export function ruleShouldSendAlertsToggled(params: ruleShouldSendAlertsToggledParams): LogObject<ruleShouldSendAlertsToggledParams> {
  return { evid: 3307, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'ruleBuildBreakingScheduled' event (evid: 3308)
 *
 * Event description: Sent when a rule owner schedules the rule to start breaking builds at a certain date
 *
 * @param {ruleBuildBreakingScheduledParams} params - The parameters for this event
 * @property {string} ruleName - Which rule is being scheduled
 * @property {DateTime} gracePeriodStartDate - The date that the rule's grace period will begin
 * @property {DateTime} buildBreakingStartDate - The date that the rule will start breaking builds
 * @property {string} userName - The user name that scheduled  the rule (not the rule owner)
 * @return {LogObject<ruleBuildBreakingScheduledParams>} LogObject<ruleBuildBreakingScheduledParams>
 */
export function ruleBuildBreakingScheduled(params: ruleBuildBreakingScheduledParams): LogObject<ruleBuildBreakingScheduledParams> {
  return { evid: 3308, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'ciPoliceDeadlineSchedule' event (evid: 3309)
 *
 * Event description: Sent every time violation_id has a new deadline (whether an initial deadline or committed to a new deadline)
 *
 * @param {ciPoliceDeadlineScheduleParams} params - The parameters for this event
 * @property {string} artifactId - artifact id
 * @property {string} ruleName - rule name
 * @property {string} userConfirm - The user who confirmed the new deadline (null if initial deadline). User email without "@wix.com".
 * @property {string} userCommit - The user who committed to a new deadline (null if initial deadline). User email without "@wix.com".
 * @property {DateTime} deadline - violation_id's deadline (whether an initial deadline or committed to a new deadline)
 * @property {string} violationId - violation id
 * @return {LogObject<ciPoliceDeadlineScheduleParams>} LogObject<ciPoliceDeadlineScheduleParams>
 */
export function ciPoliceDeadlineSchedule(params: ciPoliceDeadlineScheduleParams): LogObject<ciPoliceDeadlineScheduleParams> {
  return { evid: 3309, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'projectPerformedEmergencyOptOutOfRule' event (evid: 3310)
 *
 * Event description: Sent every time a user requests an emergency opt out (24 hours) of a rule for a specific project (3302 is the event for non-emergency opt outs) and a specific violation
 *
 * @param {projectPerformedEmergencyOptOutOfRuleParams} params - The parameters for this event
 * @property {string} ruleName - From which rule is the project being opted out
 * @property {string} projectName - Name of project that is being opted out
 * @property {string} userEmail - Which user is opting out the project
 * @property {string} reason - Request's reason for emergency opt out
 * @property {string} violationId - violation_id
 * @property {number} consecutiveOptOuts - Number of consecutive EOOs per rule since the last time it was green
 * @return {LogObject<projectPerformedEmergencyOptOutOfRuleParams>} LogObject<projectPerformedEmergencyOptOutOfRuleParams>
 */
export function projectPerformedEmergencyOptOutOfRule(params: projectPerformedEmergencyOptOutOfRuleParams): LogObject<projectPerformedEmergencyOptOutOfRuleParams> {
  return { evid: 3310, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixStandardsStartFalconRunTimeExperimentSrc11Evid33100' event (evid: 33100)
 *
 * Event description: Sent every time a Wix Standards Check is started
 *
 * @param {wixStandardsStartFalconRunTimeExperimentSrc11Evid33100Params} params - The parameters for this event
 * @property {string} projectName - project_name
 * @property {string} projectType - project_type
 * @property {string} mode - Represent the mode Wix Standards is running on
 * @property {GUID} taskId - guid for evert task as part of a build run
 * @property {GUID} buildRunId - guid for every build run
 * @property {string} repoName - Repository name
 * @return {LogObject<wixStandardsStartFalconRunTimeExperimentSrc11Evid33100Params>} LogObject<wixStandardsStartFalconRunTimeExperimentSrc11Evid33100Params>
 */
export function wixStandardsStartFalconRunTimeExperimentSrc11Evid33100(params: wixStandardsStartFalconRunTimeExperimentSrc11Evid33100Params): LogObject<wixStandardsStartFalconRunTimeExperimentSrc11Evid33100Params> {
  return { evid: 33100, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixStandardsEndFalconRunTimeExperimentSrc11Evid33101' event (evid: 33101)
 *
 * Event description: Sent every time a Wix Standards Check is ended
 *
 * @param {wixStandardsEndFalconRunTimeExperimentSrc11Evid33101Params} params - The parameters for this event
 * @property {string} projectName - project name
 * @property {string} projectType - project type
 * @property {string} mode - Represent the mode Wix Standards is running on
 * @property {GUID} taskId - guid for evert task as part of a build run
 * @property {GUID} buildRunId - guid for every build run
 * @property {string} runStatus - status of the run
 * @property {string} repoName - Repository name
 * @return {LogObject<wixStandardsEndFalconRunTimeExperimentSrc11Evid33101Params>} LogObject<wixStandardsEndFalconRunTimeExperimentSrc11Evid33101Params>
 */
export function wixStandardsEndFalconRunTimeExperimentSrc11Evid33101(params: wixStandardsEndFalconRunTimeExperimentSrc11Evid33101Params): LogObject<wixStandardsEndFalconRunTimeExperimentSrc11Evid33101Params> {
  return { evid: 33101, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'deadlineAlert' event (evid: 3311)
 *
 * Event description: This event is created for each deadline alert sent.
 *
 * @param {deadlineAlertParams} params - The parameters for this event
 * @property {string} ruleName - the name of the rule that failed
 * @property {DateTime} dateOfDeadline - the date of the actual deadline
 * @property {number} numOfAvailableAutofixes - shows number of projects in message where autofix is available
 * @property {string} ownershipTag - the name of the ownership tag
 * @property {number} numOfProjects - shows number of projects in message
 * @return {LogObject<deadlineAlertParams>} LogObject<deadlineAlertParams>
 */
export function deadlineAlert(params: deadlineAlertParams): LogObject<deadlineAlertParams> {
  return { evid: 3311, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'fixButtonClicked' event (evid: 3312)
 *
 * Event description: This event is sent each time the "fix button" is pressed (in Robocop)
 *
 * @param {fixButtonClickedParams} params - The parameters for this event
 * @property {string} slackId - the id of the slack message (can use to connect between events 3315/3401/3312)
 * @property {string} projectName - the name of the project
 * @property {string} ownershipTag - the name of the ownershipTag
 * @return {LogObject<fixButtonClickedParams>} LogObject<fixButtonClickedParams>
 */
export function fixButtonClicked(params: fixButtonClickedParams): LogObject<fixButtonClickedParams> {
  return { evid: 3312, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'autofixReportSent' event (evid: 3313)
 *
 * Event description: Sent when the process of creating a PR is finished (whether it was successful or not)
 *
 * @param {autofixReportSentParams} params - The parameters for this event
 * @property {number} numOfRulesUnfixed - num of rules that were unfixed (if any)
 * @property {string} projectName - the name of the project
 * @property {string} prURL - the link (url) of the PR, will be null if the pr wasn't created successfully (can result in general error/ zero diff/ fail)
 * @property {number} numOfRulesFixed - num of rules that were fixed
 * @property {string} ownershipTag - the owner of the project
 * @return {LogObject<autofixReportSentParams>} LogObject<autofixReportSentParams>
 */
export function autofixReportSent(params: autofixReportSentParams): LogObject<autofixReportSentParams> {
  return { evid: 3313, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'viewPrButtonClick' event (evid: 3314)
 *
 * Event description: Sent for each view PR button click (relevant only if the pr was created successfully in evid 3313)
 *
 * @param {viewPrButtonClickParams} params - The parameters for this event
 * @property {string} projectName - the name of the project
 * @property {string} prURL - the link (url) of the pr
 * @property {string} ownershipTag - the name of the ownership tag
 * @property {string} userName - user name that pressed on the pr (taken from slack)
 * @return {LogObject<viewPrButtonClickParams>} LogObject<viewPrButtonClickParams>
 */
export function viewPrButtonClick(params: viewPrButtonClickParams): LogObject<viewPrButtonClickParams> {
  return { evid: 3314, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'weeklyReportButtonAction' event (evid: 3315)
 *
 * Event description: Sent every time a user clicks a button out of the different options on the weekly report.
 *
 * @param {weeklyReportButtonActionParams} params - The parameters for this event
 * @property {string} slackId - the id of the slack message (can use to connect between events 3315/3401/3312)
 * @property {string} ruleName - the rule for which the button was clicked (can be null if the button clicked is 'full report' / 'alert settings')
 * @property {string} projectName - the project name
 * @property {string} buttonAction - the button clicked by the user (currently 'learn more' / 'get support' / 'full report' / 'alert settings' )
 * @property {string} ruleState - the state ('warning' / 'failed') of the rule for which the button was clicked (should be null if the button is 'full report' / 'alert settings'
 * @property {string} ownershipTag - Name of the ownership tag
 * @return {LogObject<weeklyReportButtonActionParams>} LogObject<weeklyReportButtonActionParams>
 */
export function weeklyReportButtonAction(params: weeklyReportButtonActionParams): LogObject<weeklyReportButtonActionParams> {
  return { evid: 3315, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixStandardsInitialExtensionWasAddedSrc11Evid3316' event (evid: 3316)
 *
 * Event description: Sent every time Initial Extension feature is changing (On/Off)
 *
 * @param {wixStandardsInitialExtensionWasAddedSrc11Evid3316Params} params - The parameters for this event
 * @property {string} ruleName - Rule name
 * @property {number} threshold - The number of days beyond the original deadline in which extension requests will still be sent to the quality owner and not (yet) to the rule owner. 0 means feature turn off.
 * @return {LogObject<wixStandardsInitialExtensionWasAddedSrc11Evid3316Params>} LogObject<wixStandardsInitialExtensionWasAddedSrc11Evid3316Params>
 */
export function wixStandardsInitialExtensionWasAddedSrc11Evid3316(params: wixStandardsInitialExtensionWasAddedSrc11Evid3316Params): LogObject<wixStandardsInitialExtensionWasAddedSrc11Evid3316Params> {
  return { evid: 3316, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'ruleStatusChanged' event (evid: 3317)
 *
 * Event description: Sent every time CI Police runs (for each rule and project result)
 *
 * @param {ruleStatusChangedParams} params - The parameters for this event
 * @property {string} ruleName - The rule name
 * @property {string} projectName - The project name
 * @property {number} numOfViolationsOptedOut - The number of violations that opted out (regardless of their status) in this run
 * @property {string} repoName - The repo name
 * @property {number} numOfViolationsFailing - The number of violations that failed in this run
 * @property {string} status - The status of the run (fail/pass/warning/disabled/opt_out_disabled/opt_out_failing/opt_out_indefinitely/opt_out_passing/opt_out_warning)
 * @property {number} numOfViolationsWarning - The number of violations that had a warning status in this run
 * @return {LogObject<ruleStatusChangedParams>} LogObject<ruleStatusChangedParams>
 */
export function ruleStatusChanged(params: ruleStatusChangedParams): LogObject<ruleStatusChangedParams> {
  return { evid: 3317, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'ciPoliceNumberOfTargets' event (evid: 3318)
 *
 * Event description: Reports the number of unique targets in Bazel build that triggers CI Police
 *
 * @param {ciPoliceNumberOfTargetsParams} params - The parameters for this event
 * @property {number} numOfTargets - the number of unique targets in Bazel build that triggers CI Police
 * @return {LogObject<ciPoliceNumberOfTargetsParams>} LogObject<ciPoliceNumberOfTargetsParams>
 */
export function ciPoliceNumberOfTargets(params: ciPoliceNumberOfTargetsParams): LogObject<ciPoliceNumberOfTargetsParams> {
  return { evid: 3318, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'violationsDeadlineSrc11Evid3319' event (evid: 3319)
 *
 * Event description: Sent every time a violation has a new deadline 
 *
 * @param {violationsDeadlineSrc11Evid3319Params} params - The parameters for this event
 * @property {string} ruleName - Rule name
 * @property {string} projectName - Project name
 * @property {string} violationId - Violation id
 * @property {DateTime} deadline - Current deadline of a violation
 * @property {string} violationStatus - Warning / Error
 * @property {string} deadlineOrigin - Committed to deadline / Committed to a new deadline / Emergency opt out / Permanent opt out etc.
 * @property {string} userEmail - The user in charge of the deadline as determined by it’s origin (if exists)
 * @return {LogObject<violationsDeadlineSrc11Evid3319Params>} LogObject<violationsDeadlineSrc11Evid3319Params>
 */
export function violationsDeadlineSrc11Evid3319(params: violationsDeadlineSrc11Evid3319Params): LogObject<violationsDeadlineSrc11Evid3319Params> {
  return { evid: 3319, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'executiveSummaryEmailSentSrc11Evid3320' event (evid: 3320)
 *
 * Event description: Sent when an Email is sent to a manager
 *
 * @param {executiveSummaryEmailSentSrc11Evid3320Params} params - The parameters for this event
 * @property {string} userName - Username of the manager who got the email
 * @property {string} typeOfUser - Regular / Manager / MoM
 * @return {LogObject<executiveSummaryEmailSentSrc11Evid3320Params>} LogObject<executiveSummaryEmailSentSrc11Evid3320Params>
 */
export function executiveSummaryEmailSentSrc11Evid3320(params: executiveSummaryEmailSentSrc11Evid3320Params): LogObject<executiveSummaryEmailSentSrc11Evid3320Params> {
  return { evid: 3320, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'executiveSummaryEnterOverviewSrc11Evid3321' event (evid: 3321)
 *
 * Event description: Sent when a manager press the link to vanguard via email or enter the overview dashboard manually
 *
 * @param {executiveSummaryEnterOverviewSrc11Evid3321Params} params - The parameters for this event
 * @property {string} userName - Username of the manager who entered the overview dashboard
 * @property {string} refferalInfo - Entry point ('Email' or 'Manual')
 * @property {string} typeOfUser - Regular / Manager / MoM
 * @return {LogObject<executiveSummaryEnterOverviewSrc11Evid3321Params>} LogObject<executiveSummaryEnterOverviewSrc11Evid3321Params>
 */
export function executiveSummaryEnterOverviewSrc11Evid3321(params: executiveSummaryEnterOverviewSrc11Evid3321Params): LogObject<executiveSummaryEnterOverviewSrc11Evid3321Params> {
  return { evid: 3321, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'executiveSummaryMovingBetweenTabsSrc11Evid3322' event (evid: 3322)
 *
 * Event description: Sent every time user is moving from one tab (calendar preset) to another
 *
 * @param {executiveSummaryMovingBetweenTabsSrc11Evid3322Params} params - The parameters for this event
 * @property {string} userName - Username of the manager
 * @property {string} destinationTab - The tab (calendar preset) the user moved to
 * @property {string} typeOfUser - Regular / Manager / MoM
 * @return {LogObject<executiveSummaryMovingBetweenTabsSrc11Evid3322Params>} LogObject<executiveSummaryMovingBetweenTabsSrc11Evid3322Params>
 */
export function executiveSummaryMovingBetweenTabsSrc11Evid3322(params: executiveSummaryMovingBetweenTabsSrc11Evid3322Params): LogObject<executiveSummaryMovingBetweenTabsSrc11Evid3322Params> {
  return { evid: 3322, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'executiveSummaryCommitToDeadlineSrc11Evid3323' event (evid: 3323)
 *
 * Event description: Sent when a manager committed to a deadline (new one or default) or permanently opt-out 
 *
 * @param {executiveSummaryCommitToDeadlineSrc11Evid3323Params} params - The parameters for this event
 * @property {string} userName - Manager's username who conducted the action
 * @property {string} projectName - Project name
 * @property {string} ruleName - Rule name
 * @property {string} action - The action that was performed ('Commit', 'Commit to A Deadline', 'Permanently opt-out')
 * @property {DateTime} initialDeadline - The default deadline set by the rule owner
 * @property {DateTime} newDeadline - The new deadline committed by the manger (null if action = ‘Commit’ or action = ‘Permanently opt-out’)
 * @property {string} typeOfUser - Regular / Manager / MoM
 * @return {LogObject<executiveSummaryCommitToDeadlineSrc11Evid3323Params>} LogObject<executiveSummaryCommitToDeadlineSrc11Evid3323Params>
 */
export function executiveSummaryCommitToDeadlineSrc11Evid3323(params: executiveSummaryCommitToDeadlineSrc11Evid3323Params): LogObject<executiveSummaryCommitToDeadlineSrc11Evid3323Params> {
  return { evid: 3323, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'executiveSummaryCustomTimeRangeSrc11Evid3324' event (evid: 3324)
 *
 * Event description: Sent when a user manually sets a custom time range
 *
 * @param {executiveSummaryCustomTimeRangeSrc11Evid3324Params} params - The parameters for this event
 * @property {string} userName - Manager's username who set a custom time range
 * @property {DateTime} startingDate - Starting date
 * @property {DateTime} closingDate - End date
 * @property {string} typeOfUser - Regular / Manager / MoM
 * @return {LogObject<executiveSummaryCustomTimeRangeSrc11Evid3324Params>} LogObject<executiveSummaryCustomTimeRangeSrc11Evid3324Params>
 */
export function executiveSummaryCustomTimeRangeSrc11Evid3324(params: executiveSummaryCustomTimeRangeSrc11Evid3324Params): LogObject<executiveSummaryCustomTimeRangeSrc11Evid3324Params> {
  return { evid: 3324, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'executiveSummaryChangeTeamSrc11Evid3325' event (evid: 3325)
 *
 * Event description: Sent when a user manually changes the team view
 *
 * @param {executiveSummaryChangeTeamSrc11Evid3325Params} params - The parameters for this event
 * @property {string} userName - Manager's username who changed the team view
 * @property {string} impersonateUserName - The user to whom the manager changed the view
 * @property {string} typeOfUser - Regular / Manager / MoM
 * @return {LogObject<executiveSummaryChangeTeamSrc11Evid3325Params>} LogObject<executiveSummaryChangeTeamSrc11Evid3325Params>
 */
export function executiveSummaryChangeTeamSrc11Evid3325(params: executiveSummaryChangeTeamSrc11Evid3325Params): LogObject<executiveSummaryChangeTeamSrc11Evid3325Params> {
  return { evid: 3325, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixStandardsEmergencyOptOutPopupMessageSrc11Evid3326' event (evid: 3326)
 *
 * Event description: Sent every time a popup message appears to the user
 *
 * @param {wixStandardsEmergencyOptOutPopupMessageSrc11Evid3326Params} params - The parameters for this event
 * @property {string} projectName - Name of project that is being opted out
 * @property {string} userEmail - Which user is opting out the project
 * @property {string} action - "Submit" / "Close" (close button or x) 
 * @property {string} rulesNamesArray - Array of rules names that are being opted out
 * @return {LogObject<wixStandardsEmergencyOptOutPopupMessageSrc11Evid3326Params>} LogObject<wixStandardsEmergencyOptOutPopupMessageSrc11Evid3326Params>
 */
export function wixStandardsEmergencyOptOutPopupMessageSrc11Evid3326(params: wixStandardsEmergencyOptOutPopupMessageSrc11Evid3326Params): LogObject<wixStandardsEmergencyOptOutPopupMessageSrc11Evid3326Params> {
  return { evid: 3326, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixStandardsProjectWasRejectedAndNotAddedToTheIgnoreListSrc11Evid3332' event (evid: 3332)
 *
 * Event description: Sent every time a rule is rejected and not added to ignore list for a specific project and specific violation 
 *
 * @param {wixStandardsProjectWasRejectedAndNotAddedToTheIgnoreListSrc11Evid3332Params} params - The parameters for this event
 * @property {string} ruleName - rule name
 * @property {string} violationId - A violation id that indicated where in the code the violation was made
 * @property {string} projectName - project name
 * @property {string} applicationGroupId - the group id of the application
 * @property {string} applicationItemId - the item id of the application
 * @property {string} addedBy - who rejected the 
 * the request
 * @return {LogObject<wixStandardsProjectWasRejectedAndNotAddedToTheIgnoreListSrc11Evid3332Params>} LogObject<wixStandardsProjectWasRejectedAndNotAddedToTheIgnoreListSrc11Evid3332Params>
 */
export function wixStandardsProjectWasRejectedAndNotAddedToTheIgnoreListSrc11Evid3332(params: wixStandardsProjectWasRejectedAndNotAddedToTheIgnoreListSrc11Evid3332Params): LogObject<wixStandardsProjectWasRejectedAndNotAddedToTheIgnoreListSrc11Evid3332Params> {
  return { evid: 3332, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixStandardsOptOutRequestsApplicationClickSrc11Evid3344' event (evid: 3344)
 *
 * Event description: Sent every time a user click on an application
 *
 * @param {wixStandardsOptOutRequestsApplicationClickSrc11Evid3344Params} params - The parameters for this event
 * @property {string} request_status - pending/resolved
 * @property {string} action - handle/view
 * @property {string} ruleName - the name of the rule
 * @property {DateTime} requestedDate - the date of the request
 * @property {string} applicationGroupId - the id of application request
 * @property {string} requestType - new_deadline/permenat_opt_otu
 * @property {string} ruleOwnerEmail - the email of the rule owner
 * @property {string} projectOwnerEmail - the email of the project owner
 * @return {LogObject<wixStandardsOptOutRequestsApplicationClickSrc11Evid3344Params>} LogObject<wixStandardsOptOutRequestsApplicationClickSrc11Evid3344Params>
 */
export function wixStandardsOptOutRequestsApplicationClickSrc11Evid3344(params: wixStandardsOptOutRequestsApplicationClickSrc11Evid3344Params): LogObject<wixStandardsOptOutRequestsApplicationClickSrc11Evid3344Params> {
  return { evid: 3344, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixStandardsOptOutRequestsApplicationActionSrc11Evid3345' event (evid: 3345)
 *
 * Event description: Sent every time a rule owner do an  action on an application group
 *
 * @param {wixStandardsOptOutRequestsApplicationActionSrc11Evid3345Params} params - The parameters for this event
 * @property {string} action - close/confirm
 * @property {string} Projects - projects json 
 * @property {DateTime} requestedDate - the date of the request
 * @property {string} applicationGroupId - the id of application request
 * @property {string} requestType -  new deadline/permanent opt out)
 * @property {number} totalViolations - total violations
 * @property {string} ruleOwnerEmail - The email of the rule owner
 * @property {string} projectOwnerEmail - The email of the project owner
 * @return {LogObject<wixStandardsOptOutRequestsApplicationActionSrc11Evid3345Params>} LogObject<wixStandardsOptOutRequestsApplicationActionSrc11Evid3345Params>
 */
export function wixStandardsOptOutRequestsApplicationActionSrc11Evid3345(params: wixStandardsOptOutRequestsApplicationActionSrc11Evid3345Params): LogObject<wixStandardsOptOutRequestsApplicationActionSrc11Evid3345Params> {
  return { evid: 3345, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'weeklyStatusReport' event (evid: 3401)
 *
 * Event description: Weekly reports for each project about failing and warning rules
 *
 * @param {weeklyStatusReportParams} params - The parameters for this event
 * @property {string} slackId - the id of the slack message (can use to connect between events 3315/3401/3312)
 * @property {string} result - the result of sending the message can be 'sent' | 'no_ownership_tag' | 'no_errors_or_warnings'
 * @property {string} slack_channel - slack channel
 * @property {number} numRulesFailed - amount of rules reported as failing
 * @property {number} numRulesWarning - amount of rules reported as warning
 * @property {string} ownership_tag - ownership tag
 * @property {number} numOfAvailableAutofixes - num of available projects to fix
 * @property {string} project_name - project name
 * @return {LogObject<weeklyStatusReportParams>} LogObject<weeklyStatusReportParams>
 */
export function weeklyStatusReport(params: weeklyStatusReportParams): LogObject<weeklyStatusReportParams> {
  return { evid: 3401, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixStandardsBotWeeklyAlertMessageWasSentSrc11Evid3402' event (evid: 3402)
 *
 * Event description: Weekly reports per ownership tag
 *
 * @param {wixStandardsBotWeeklyAlertMessageWasSentSrc11Evid3402Params} params - The parameters for this event
 * @property {string} slack_id - the id of the slack message (can use to connect between events 3315/3401/3312)
 * @property {string} slack_channel - slack channel 
 * @property {string} ownership_tag - ownership tag
 * @property {boolean} is_empty - empty message (without upcoming violations)
 * @return {LogObject<wixStandardsBotWeeklyAlertMessageWasSentSrc11Evid3402Params>} LogObject<wixStandardsBotWeeklyAlertMessageWasSentSrc11Evid3402Params>
 */
export function wixStandardsBotWeeklyAlertMessageWasSentSrc11Evid3402(params: wixStandardsBotWeeklyAlertMessageWasSentSrc11Evid3402Params): LogObject<wixStandardsBotWeeklyAlertMessageWasSentSrc11Evid3402Params> {
  return { evid: 3402, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixStandardsBotWeeklyViolationAlertMessageWasSentSrc11Evid3403' event (evid: 3403)
 *
 * Event description: Weekly report per violation and ownership tag
 *
 * @param {wixStandardsBotWeeklyViolationAlertMessageWasSentSrc11Evid3403Params} params - The parameters for this event
 * @property {string} slack_id - the id of the slack message (can use to connect between events 3315/3401/3312)
 * @property {string} slack_channel - slack channel 
 * @property {string} violation_status - error/warning
 * @property {string} ownership_tag - ownership tag
 * @property {string} project_name - project name
 * @property {string} violation_id - violation id
 * @property {string} rule_name - rule name
 * @property {DateTime} deadline - deadline of the violation yyyy-mm-dd
 * @property {DateTime} new_deadline - new_deadline 
 * @property {number} rank - rank of the violation in the message
 * @return {LogObject<wixStandardsBotWeeklyViolationAlertMessageWasSentSrc11Evid3403Params>} LogObject<wixStandardsBotWeeklyViolationAlertMessageWasSentSrc11Evid3403Params>
 */
export function wixStandardsBotWeeklyViolationAlertMessageWasSentSrc11Evid3403(params: wixStandardsBotWeeklyViolationAlertMessageWasSentSrc11Evid3403Params): LogObject<wixStandardsBotWeeklyViolationAlertMessageWasSentSrc11Evid3403Params> {
  return { evid: 3403, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixStandardsBotWeeklyAlertMessageButtonActionSrc11Evid3404' event (evid: 3404)
 *
 * Event description: Button action for violation and ownership tag
 *
 * @param {wixStandardsBotWeeklyAlertMessageButtonActionSrc11Evid3404Params} params - The parameters for this event
 * @property {string} slack_id - the id of the slack message (can use to connect between events 3315/3401/3312)
 * @property {string} slack_channel - slack channel 
 * @property {string} violation_status - error/warning
 * @property {string} ownership_tag - ownership tag
 * @property {string} project_name - project name
 * @property {string} violation_id - violation id
 * @property {string} rule_name - rule name
 * @property {DateTime} deadline - deadline of the violation yyyy-mm-dd
 * @property {DateTime} new_deadline - new_deadline 
 * @property {number} rank - rank of the violation in the message
 * @property {string} button_action - the button clicked by the user (currently 'learn more' / 'get support' / 'full report' / 'alert settings' /'summary')
 * @return {LogObject<wixStandardsBotWeeklyAlertMessageButtonActionSrc11Evid3404Params>} LogObject<wixStandardsBotWeeklyAlertMessageButtonActionSrc11Evid3404Params>
 */
export function wixStandardsBotWeeklyAlertMessageButtonActionSrc11Evid3404(params: wixStandardsBotWeeklyAlertMessageButtonActionSrc11Evid3404Params): LogObject<wixStandardsBotWeeklyAlertMessageButtonActionSrc11Evid3404Params> {
  return { evid: 3404, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'arkGradualRolloutStarted' event (evid: 3604)
 *
 * Event description: gradual rollout started
 *
 * @param {arkGradualRolloutStartedParams} params - The parameters for this event
 * @property {string} pipeline_name - pipe line type of the rollout
 * @property {string} onAlertBehavior - "Acknowledge"/"Terminate"
 * @property {string} version - version
 * @property {string} artifact_id - artifact_id
 * @property {string} rolloutId - A unique ID per rollout
 * @property {string} mode - progression mode - "Auto"/"Manual"
 * @property {number} timestampMs - The event's creation time
 * @property {string} artifact_type - artifact type
 * @property {string} deployment_id - Deployment id
 * @property {string} user - Who initiated the rollout
 * @return {LogObject<arkGradualRolloutStartedParams>} LogObject<arkGradualRolloutStartedParams>
 */
export function arkGradualRolloutStarted(params: arkGradualRolloutStartedParams): LogObject<arkGradualRolloutStartedParams> {
  return { evid: 3604, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'arkGradualRolloutStepChanged' event (evid: 3605)
 *
 * Event description: gradual rollout step changed
 *
 * @param {arkGradualRolloutStepChangedParams} params - The parameters for this event
 * @property {string} step_name - step name
 * @property {string} onAlertBehavior - "Acknowledge"/"Terminate"
 * @property {string} exposure - traffic
 * @property {string} version - version
 * @property {string} artifact_id - artifact_id
 * @property {string} rolloutId - deployment ID
 * @property {string} mode - "Auto"/"Manual"
 * @property {number} timestampMs - The event's creation time
 * @property {string} artifact_type - artifact type
 * @property {string} user - Who is responsible for the step change
 * @return {LogObject<arkGradualRolloutStepChangedParams>} LogObject<arkGradualRolloutStepChangedParams>
 */
export function arkGradualRolloutStepChanged(params: arkGradualRolloutStepChangedParams): LogObject<arkGradualRolloutStepChangedParams> {
  return { evid: 3605, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'arkGradualRolloutEnded' event (evid: 3606)
 *
 * Event description: gradual_rollout_ended
 *
 * @param {arkGradualRolloutEndedParams} params - The parameters for this event
 * @property {string} step_name - step name
 * @property {string} pipeline_name - pipe line type of the rollout
 * @property {string} onAlertBehavior - "Acknowledge"/"Terminate"
 * @property {string} reason - success, error, internal_error, push_GA_manually, stop_button_clicked
 * @property {string} exposure - traffic
 * @property {string} version - version
 * @property {string} artifact_id - artifact_id
 * @property {string} error_description - error_description (null if success)
 * @property {string} rolloutId - deployment ID
 * @property {string} mode - "Auto"/"Manual"
 * @property {number} timestampMs - The event's creation time
 * @property {string} artifact_type - artifact type
 * @property {string} user - Who is ending the rollout
 * @property {string} specific_reason - Extension of the 'reason' field. Holds the specific reason of a deployment error (free field).
 * @return {LogObject<arkGradualRolloutEndedParams>} LogObject<arkGradualRolloutEndedParams>
 */
export function arkGradualRolloutEnded(params: arkGradualRolloutEndedParams): LogObject<arkGradualRolloutEndedParams> {
  return { evid: 3606, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'arkNewProjectOnboarded' event (evid: 3608)
 *
 * Event description: A new project has completed the ARK Onboarding process successfully
 *
 * @param {arkNewProjectOnboardedParams} params - The parameters for this event
 * @property {string} artifactId - Full artifact ID of project being onboarded (including group ID)
 * @property {string} onboardingMethod - "Manual"/"Onboarding Site"
 * @property {string} artifact_type - Server/Client/Business Manager/Fullstack/OOI App/Other
 * @return {LogObject<arkNewProjectOnboardedParams>} LogObject<arkNewProjectOnboardedParams>
 */
export function arkNewProjectOnboarded(params: arkNewProjectOnboardedParams): LogObject<arkNewProjectOnboardedParams> {
  return { evid: 3608, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'ciPoliceTicketPageLoad' event (evid: 3620)
 *
 * Event description: Sent when the CI Police Ticket page has finished loaded for a certain project
 *
 * @param {ciPoliceTicketPageLoadParams} params - The parameters for this event
 * @property {string} projectName - Name of the project we are looking at
 * @property {string} tag - "master"/"pr num X"
 * @property {string} origin - How did we get to this page: "CI"/"Slack"/"Rule Page"/"Falcon Github Comment"
 * @property {string} sessionId - A unique session ID
 * @property {string} platform - "dev-portal"/"station"
 * @return {LogObject<ciPoliceTicketPageLoadParams>} LogObject<ciPoliceTicketPageLoadParams>
 */
export function ciPoliceTicketPageLoad(params: ciPoliceTicketPageLoadParams): LogObject<ciPoliceTicketPageLoadParams> {
  return { evid: 3620, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'ciPoliceTicketProjectButtonAction' event (evid: 3627)
 *
 * Event description: Sent when a user clicks on one of the actions for a specific project in the CI Police Ticket page
 *
 * @param {ciPoliceTicketProjectButtonActionParams} params - The parameters for this event
 * @property {string} projectName - Name of the project we are looking at
 * @property {string} buttonAction - "Go to source code"/"Go to CI Build"/"Show Rules in Development"/"Hide Rules in Development"/"Hide permanent opt outs"/"Show permanent opt outs"/"Learn more"/"Autofix"
 * @property {string} sessionId - A unique session ID
 * @property {string} platform - "dev-portal"/"station"
 * @return {LogObject<ciPoliceTicketProjectButtonActionParams>} LogObject<ciPoliceTicketProjectButtonActionParams>
 */
export function ciPoliceTicketProjectButtonAction(params: ciPoliceTicketProjectButtonActionParams): LogObject<ciPoliceTicketProjectButtonActionParams> {
  return { evid: 3627, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'ciPoliceTicketRuleButtonAction' event (evid: 3628)
 *
 * Event description: Sent when a user clicks on one of the actions for a specific rule in a project's CI Police Ticket page
 *
 * @param {ciPoliceTicketRuleButtonActionParams} params - The parameters for this event
 * @property {string} ruleName - The rule for which we are clicking the button
 * @property {string} projectName - Name of the project we are looking at
 * @property {string} buttonAction - "Support Channel"/"Go to Rule Page"/"Emergency Opt Out"/"Go to rule docs"/"Regression"/"request opt out"
 * @property {string} sessionId - A unique session ID
 * @property {string} platform - "dev-portal"/"station"
 * @return {LogObject<ciPoliceTicketRuleButtonActionParams>} LogObject<ciPoliceTicketRuleButtonActionParams>
 */
export function ciPoliceTicketRuleButtonAction(params: ciPoliceTicketRuleButtonActionParams): LogObject<ciPoliceTicketRuleButtonActionParams> {
  return { evid: 3628, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'emergencyOptOutDialogAction' event (evid: 3629)
 *
 * Event description: Sent when a user clicks a CTA in the CI Police Ticket Emergency Opt Out dialog for a specific rule (for a specific project)
 *
 * @param {emergencyOptOutDialogActionParams} params - The parameters for this event
 * @property {string} projectName - Name of the project we are looking at
 * @property {string} buttonAction - "Submit"/"Cancel"/"X button"
 * @property {string} sessionId - A unique session ID
 * @property {string} platform - "dev-portal"/"station"/"dev-portal-artifact-overview"
 * @property {string} modal_name - the name of the modal (7th consecutive or regular)
 * @return {LogObject<emergencyOptOutDialogActionParams>} LogObject<emergencyOptOutDialogActionParams>
 */
export function emergencyOptOutDialogAction(params: emergencyOptOutDialogActionParams): LogObject<emergencyOptOutDialogActionParams> {
  return { evid: 3629, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'ciPoliceMsTrackerOptOutDialog' event (evid: 3630)
 *
 * Event description: Sent when a user uses the opt out dialog (user to request opt out, rule owner to approve requests)
 *
 * @param {ciPoliceMsTrackerOptOutDialogParams} params - The parameters for this event
 * @property {string} optOutReason - The reason for opting out (written by regular user or rule owner)
 * @property {string} buttonAction - submit/"Cancel"/"X button"
 * @property {string} applicationId - This id will help connect between a request and its approval (null when button action is not 'submit')
 * @property {string} actionType - The action type (approving side/ requesting side)
 * @property {string} companyName - Name of the company that requested to opt out (null if requested from rule page)
 * @property {string} origin - Indicates wether the user got to the dialog through the email or null if he originated through the regular milestone tracker flow
 * @property {DateTime} expireDate - the date the user requested to be opted out OR the date the rule owner approved (could also be never - will show as null)
 * @property {string} dialogId - An id used to connect to the event containing the rules and projects
 * @property {string} pageName - Will be 'ticket' if the request was made from ci police ticket, 'tracker' if made from milestone tracker or null if it's a approving side action
 * @property {string} platform - "dev-portal"/"station"
 * @property {string} userName - Name of the user that performed the action
 * @return {LogObject<ciPoliceMsTrackerOptOutDialogParams>} LogObject<ciPoliceMsTrackerOptOutDialogParams>
 */
export function ciPoliceMsTrackerOptOutDialog(params: ciPoliceMsTrackerOptOutDialogParams): LogObject<ciPoliceMsTrackerOptOutDialogParams> {
  return { evid: 3630, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'ciPoliceMsTrackerOptOutDialogRulesAndProjects' event (evid: 3631)
 *
 * Event description: Sent every time a request is made to commit to a new deadline or every time it's approved/denied. The event contains all the combinations of rules and projects per request (meaning per dialog id).
 *
 * @param {ciPoliceMsTrackerOptOutDialogRulesAndProjectsParams} params - The parameters for this event
 * @property {string} ruleName - The rule name that requested a new deadline
 * @property {string} projectName - The project name that requested a new deadline
 * @property {string} dialogid - An id used to connect to the event of opt out dialog
 * @return {LogObject<ciPoliceMsTrackerOptOutDialogRulesAndProjectsParams>} LogObject<ciPoliceMsTrackerOptOutDialogRulesAndProjectsParams>
 */
export function ciPoliceMsTrackerOptOutDialogRulesAndProjects(params: ciPoliceMsTrackerOptOutDialogRulesAndProjectsParams): LogObject<ciPoliceMsTrackerOptOutDialogRulesAndProjectsParams> {
  return { evid: 3631, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'ciPoliceMsTrackerButtonAction' event (evid: 3632)
 *
 * Event description: Sent for every button action that isn't sent through Cairo generic events.
 *
 * @param {ciPoliceMsTrackerButtonActionParams} params - The parameters for this event
 * @property {string} product - The product were at 'rule-view' 'company-view'
 * @property {string} buttonClicked - The button that was clicked currently 'repository link' /'copy link to share' /'export' 'documentation'/'configurations'/ click on rule owners email
 * @return {LogObject<ciPoliceMsTrackerButtonActionParams>} LogObject<ciPoliceMsTrackerButtonActionParams>
 */
export function ciPoliceMsTrackerButtonAction(params: ciPoliceMsTrackerButtonActionParams): LogObject<ciPoliceMsTrackerButtonActionParams> {
  return { evid: 3632, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixStandardsTicketEmergencyOptOutDialogOpenSrc11Evid3633' event (evid: 3633)
 *
 * Event description: Sent when a user clicks on "emergency opt out" CTA in Wix Standards
 *
 * @param {wixStandardsTicketEmergencyOptOutDialogOpenSrc11Evid3633Params} params - The parameters for this event
 * @property {string} projectName - Name of the project we are looking at
 * @property {string} sessionId - A unique session ID
 * @property {string} platform - "dev-portal"/"station"/"dev-portal-artifact-overview"
 * @property {string} modal_name - the name of the modal (7th consecutive or regular)
 * @return {LogObject<wixStandardsTicketEmergencyOptOutDialogOpenSrc11Evid3633Params>} LogObject<wixStandardsTicketEmergencyOptOutDialogOpenSrc11Evid3633Params>
 */
export function wixStandardsTicketEmergencyOptOutDialogOpenSrc11Evid3633(params: wixStandardsTicketEmergencyOptOutDialogOpenSrc11Evid3633Params): LogObject<wixStandardsTicketEmergencyOptOutDialogOpenSrc11Evid3633Params> {
  return { evid: 3633, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'lokiRepoUpdateCreated' event (evid: 3710)
 *
 * Event description: Sent when a source repo has a new update for a target repo
 *
 * @param {lokiRepoUpdateCreatedParams} params - The parameters for this event
 * @property {string} targetBranch - Should be 'loki-updates' for fallback otherwise 'master'
 * @property {string} guid - Unique ID of request: source repo, source sha, target repo
 * @property {string} schedule_type - the scheduling plan for this update (currently asap/every_3_hours/once_a_day)
 * @property {string} sourceSha - Source sha (commit) of the update
 * @property {string} correlationId - contains the relevant yolo guid of initial update  or null if its a yolo update or old loki update
 * @property {string} sourceRepo - The repo that has one or more packages that committed new data
 * @property {string} targetRepo - Which repo needs to be updated with new data
 * @return {LogObject<lokiRepoUpdateCreatedParams>} LogObject<lokiRepoUpdateCreatedParams>
 */
export function lokiRepoUpdateCreated(params: lokiRepoUpdateCreatedParams): LogObject<lokiRepoUpdateCreatedParams> {
  return { evid: 3710, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'lokiUpdatePrOpened' event (evid: 3712)
 *
 * Event description: Sent when a PR is created/updated for updating the source repo in the target repo - sent for each try number
 *
 * @param {lokiUpdatePrOpenedParams} params - The parameters for this event
 * @property {number} tryNumber - 1 if first try; >1 otherwise
 * @property {string} guid - Unique ID of request: source repo, source sha, target repo
 * @property {string} sourceSha - Source sha (commit) of the update
 * @property {string} correlationId - contains the relevant yolo guid of initial update  or null if its a yolo update or old loki update
 * @property {string} sourceRepo - The repo that has one or more packages that committed new data
 * @property {string} targetRepo - Which repo needs to be updated with new data
 * @property {boolean} isLastAutomaticRetry - TRUE if this is the last automatic retry (for current implementation, tryNumber should be = 3); FALSE otherwise
 * @property {boolean} isManualRetry - TRUE if user triggered the retry (for current implementation, tryNumber should be > 3); FALSE if it's  an automatic retry
 * @return {LogObject<lokiUpdatePrOpenedParams>} LogObject<lokiUpdatePrOpenedParams>
 */
export function lokiUpdatePrOpened(params: lokiUpdatePrOpenedParams): LogObject<lokiUpdatePrOpenedParams> {
  return { evid: 3712, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'lokiUpdatePrResult' event (evid: 3713)
 *
 * Event description: Sent when an update PR is done trying to update the source repo in the target repo - sent for each try number
 *
 * @param {lokiUpdatePrResultParams} params - The parameters for this event
 * @property {number} tryNumber - 1 if first try; > 1 otherwise
 * @property {string} updateResult - "passed"/"failed"
 * @property {string} guid - Unique ID of request: source repo, source sha, target repo
 * @property {string} prURL - Pull Request URL
 * @property {string} sourceSha - Source sha (commit) of the update
 * @property {string} correlationId - contains the relevant yolo guid of initial update  or null if its a yolo update or old loki update
 * @property {string} sourceRepo - The repo that has one or more packages that committed new data
 * @property {string} targetRepo - Which repo needs to be updated with new data
 * @property {boolean} isLastAutomaticRetry - TRUE if this is the last automatic retry (for current implementation, tryNumber should be = 3); FALSE otherwise
 * @property {boolean} isManualRetry - TRUE if user triggered the retry (for current implementation, tryNumber should be > 3); FALSE if it's an automatic retry
 * @return {LogObject<lokiUpdatePrResultParams>} LogObject<lokiUpdatePrResultParams>
 */
export function lokiUpdatePrResult(params: lokiUpdatePrResultParams): LogObject<lokiUpdatePrResultParams> {
  return { evid: 3713, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'lokiUpdateMerged' event (evid: 3714)
 *
 * Event description: Sent when an update PR is done, trying to update the source repo in the target repo; should only be sent if we have a 3713 event for the same guid with updateResult = "passed"
 *
 * @param {lokiUpdateMergedParams} params - The parameters for this event
 * @property {string} targetBranch - Should be 'loki-updates' for fallback otherwise 'master'
 * @property {number} tryNumber - 1 if first try; > 1 otherwise -- should be equal to the tryNumber for event 3713 with the same guid where updateResult = "passed"
 * @property {string} guid - Unique ID of request: source repo, source sha, target repo
 * @property {string} branch - Name of branch that was merged into master
 * @property {string} sourceSha - Source sha (commit) of the update
 * @property {string} correlationId - contains the relevant yolo guid of initial update  or null if its a yolo update or old loki update
 * @property {string} sourceRepo - The repo that has one ore more packages that committed new data
 * @property {string} targetRepo - Which repo needs to be updated with new data
 * @property {boolean} isLastAutomaticRetry - TRUE if this is the last automatic retry (for current implementation, tryNumber should be = 3); FALSE otherwise
 * @property {boolean} isManualRetry - TRUE if user triggered the retry (for current implementation, tryNumber should be > 3); FALSE if it's an automatic retry
 * @return {LogObject<lokiUpdateMergedParams>} LogObject<lokiUpdateMergedParams>
 */
export function lokiUpdateMerged(params: lokiUpdateMergedParams): LogObject<lokiUpdateMergedParams> {
  return { evid: 3714, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'lokiUpdateSkipped' event (evid: 3715)
 *
 * Event description: Sent when a repo update is skipped midway through the process
 *
 * @param {lokiUpdateSkippedParams} params - The parameters for this event
 * @property {string} targetBranch - Should be 'loki-updates' for fallback otherwise 'master'
 * @property {number} tryNumber - 0 if skipped before trying to update at all; 1 if first try; >1 otherwise
 * @property {string} guid - Unique ID of request: source repo, source sha, target repo
 * @property {string} skipReason - "Newer update available"/...
 * @property {string} sourceSha - Source sha (commit) of the update
 * @property {string} correlationId - contains the relevant yolo guid of initial update or null if its a yolo update or old loki update
 * @property {string} sourceRepo - The repo that has one ore more packages that committed new data
 * @property {string} targetRepo - Which repo needs to be updated with new data
 * @return {LogObject<lokiUpdateSkippedParams>} LogObject<lokiUpdateSkippedParams>
 */
export function lokiUpdateSkipped(params: lokiUpdateSkippedParams): LogObject<lokiUpdateSkippedParams> {
  return { evid: 3715, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'lokiScheduleChanged' event (evid: 3716)
 *
 * Event description: sent when a user changes the scheduling time
 *
 * @param {lokiScheduleChangedParams} params - The parameters for this event
 * @property {string} newSchedule - the new schedule the user choose to use (current options are asap/every_3_hours/once_a_day)
 * @property {string} oldSchedule - the schedule timing that was set before the change (current options are asap/every_3_hours/once_a_day)
 * @property {string} sourceRepo - The repo that has one ore more packages that committed new dataThe repo that has one ore more packages that committed new data
 * @property {string} targetRepo - Which repo needs to be updated with new data
 * @return {LogObject<lokiScheduleChangedParams>} LogObject<lokiScheduleChangedParams>
 */
export function lokiScheduleChanged(params: lokiScheduleChangedParams): LogObject<lokiScheduleChangedParams> {
  return { evid: 3716, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'arkProjectOptedOut' event (evid: 4300)
 *
 * Event description: Sent when a project chooses to opt out of ARK
 *
 * @param {arkProjectOptedOutParams} params - The parameters for this event
 * @property {string} artifactId - The artifact that is being opted out
 * @property {string} optOutReason - Reason that project is opting out: "from onboarding", "can't use ARK"
 * @property {string} optOutDuration - For how long is the project opting out: "2 weeks", "indefinitely"
 * @property {string} userName - The user who asked to opt out
 * @return {LogObject<arkProjectOptedOutParams>} LogObject<arkProjectOptedOutParams>
 */
export function arkProjectOptedOut(params: arkProjectOptedOutParams): LogObject<arkProjectOptedOutParams> {
  return { evid: 4300, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'arkProjectOptedIn' event (evid: 4301)
 *
 * Event description: Sent when a project chooses to opt in of ARK
 *
 * @param {arkProjectOptedInParams} params - The parameters for this event
 * @property {string} artifactId - The artifact that is being opted in
 * @property {string} userName - The user who asked to opt in, currently null
 * @return {LogObject<arkProjectOptedInParams>} LogObject<arkProjectOptedInParams>
 */
export function arkProjectOptedIn(params: arkProjectOptedInParams): LogObject<arkProjectOptedInParams> {
  return { evid: 4301, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'autofixPrMerged' event (evid: 4601)
 *
 * Event description: Sent when the autofix pr is merged
 *
 * @param {autofixPrMergedParams} params - The parameters for this event
 * @property {string} projectName - Name of the project
 * @property {string} prURL - Link to Autofix PR
 * @property {string} ownershipTag - Name of ownership tag
 * @property {string} userName - Name of user that merged the PR to master
 * @property {string} fixedRules - An array of the PR fixed rules
 * @return {LogObject<autofixPrMergedParams>} LogObject<autofixPrMergedParams>
 */
export function autofixPrMerged(params: autofixPrMergedParams): LogObject<autofixPrMergedParams> {
  return { evid: 4601, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliCliCommand' event (evid: 5200)
 *
 * Event description: Sent when a user enters a command (valid/invalid) in the Wix CLI
 *
 * @param {wixCliCliCommandParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the command was entered
 * @property {string} extraFileds - A Json of extra filed - for example - for dev & preview with embedded scripts - is_mocking_values
 * @property {boolean} isCI - Should be true if was fired from a CI environment
 * @property {boolean} isValid - Is the entered command a valid CLI command
 * @property {string} nodeVersion - The Node (full) version
 * @property {string} flags - (Optional) Flags that were added to the command (e.g. "-h")
 * @property {string} cliVersion - The CLI version
 * @property {string} projectId - The project that the users is currently working on
 * @property {string} command - The command that was entered by the user (e.g. "wix dev", "preview-deployment"). Note: This can be an invalid command.
 * @property {string} shellVersion - Which version of the shell is being used
 * @property {string} shellName - Which shell is being used
 * @property {string} flow - "Sites"/"Apps"
 * @property {string} terminalVersion - Which version of the terminal is being used
 * @property {number} siteRevision - (Optional) Site revision, if available
 * @property {string} osName - Which OS is being used
 * @property {string} terminalName - Which terminal is being used
 * @property {string} osVersion - Which version of the OS is being used
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @property {string} arguments - The arguments/params that are added to the command (comma separated list)
 * @property {string} environment - the environment used (picasso/local computer etc)
 * @property {string} tracking_id - guid for tracking a single dev machine
 * @return {LogObject<wixCliCliCommandParams>} LogObject<wixCliCliCommandParams>
 */
export function wixCliCliCommand(params: wixCliCliCommandParams): LogObject<wixCliCliCommandParams> {
  return { evid: 5200, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliCliCommandStatus' event (evid: 5201)
 *
 * Event description: Sent after a user enters a command in the Wix CLI
 *
 * @param {wixCliCliCommandStatusParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the command was entered
 * @property {string} extraFileds - A Json with extra data - for example - for build command - build statistics
 * @property {boolean} isCI - Should be true if was fired from a CI environment
 * @property {number} duration - The time it took for the command to run (in ms)
 * @property {boolean} isValid - Is the entered command a valid CLI command
 * @property {string} errorMessage - (Optional) The error message displayed, if the command was invalid
 * @property {string} nodeVersion - The Node (full) version
 * @property {string} flags - (Optional) Flags that were added to the command (e.g. "-h")
 * @property {string} cliVersion - The CLI version
 * @property {string} projectId - The project that the users is currently working on
 * @property {string} command - The command that was entered by the user (e.g. "wix dev", "preview-deployment"). Note: This can be an invalid command.
 * @property {boolean} isSuccess - Was the command successful
 * @property {string} extensions - Jsom of extensions type & number of each extensions: {side_bar_category:3,dashboard_page:4...}
 * @property {string} errorType - (Optional) The error type, if the command was invalid - User/ System error
 * @property {string} shellVersion - Which version of the shell is being used
 * @property {string} shellName - Which shell is being used
 * @property {string} flow - "Sites"/"Apps"
 * @property {string} terminalVersion - Which version of the terminal is being used
 * @property {number} siteRevision - (Optional) Site revision, if available
 * @property {string} failedStep - (Optional) If the generation was unsuccessful, which step failed
 * @property {string} osName - Which OS is being used
 * @property {string} errorName - The error name - a generic name for a group off errors. (Optional) if the command was invalid
 * @property {string} suggestion - (Optional) Which suggestion was shown to the user, if any
 * @property {string} terminalName - Which terminal is being used
 * @property {string} osVersion - Which version of the OS is being used
 * @property {string} previewUrl - The preview url that the user gets from us, can be null (will be sent only for preview command)
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @property {string} arguments - The arguments/params that are added to the command (comma separated list)
 * @property {number} customKeys - In Headless project - counting the number of custom keys entered by the user, using wix-env command
 * @property {string} environment - the environment used (picasso/local computer etc)
 * @property {string} tracking_id - guid for a tracking  a single dev machine
 * @property {string} finish_status - headless start from cli flow - site_created_with_repo / site_created_without_repo / technical_fail / abandoned.
 * @return {LogObject<wixCliCliCommandStatusParams>} LogObject<wixCliCliCommandStatusParams>
 */
export function wixCliCliCommandStatus(params: wixCliCliCommandStatusParams): LogObject<wixCliCliCommandStatusParams> {
  return { evid: 5201, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliFileFolderCreatedRenamedDeleted' event (evid: 5202)
 *
 * Event description: Sent when a user creates, renames or deletes a file/folder in the local flow using Wix CLI
 *
 * @param {wixCliFileFolderCreatedRenamedDeletedParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the command was entered
 * @property {boolean} isCI - Should be true if was fired from a CI environment
 * @property {string} path - Full path of the file/folder after its creation/rename (e.g. "backend/media-control.jsw"), or name of the file that has been deleted
 * @property {string} nodeVersion - The Node (full) version
 * @property {string} cliVersion - The CLI version
 * @property {string} oldPath - (Optional) Previous full path of the file/folder, in case action = "Rename"
 * @property {string} sectionName - Section name ("public"/"backend"/"other")
 * @property {string} shellVersion - Which version of the shell is being used
 * @property {string} shellName - Which shell is being used
 * @property {string} flow - "Sites"/"Apps"
 * @property {string} terminalVersion - Which version of the terminal is being used
 * @property {number} siteRevision - (Optional) Site revision
 * @property {string} osName - Which OS is being used
 * @property {string} terminalName - Which terminal is being used
 * @property {string} type - Type of the created object: "folder"/file extension
 * @property {string} osVersion - Which version of the OS is being used
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @property {string} action - "Create" / "Rename" / "Delete"
 * @property {string} environment - the environment used (picasso/local computer etc)
 * @property {string} tracking_id - guid for tracking a single dev machine
 * @return {LogObject<wixCliFileFolderCreatedRenamedDeletedParams>} LogObject<wixCliFileFolderCreatedRenamedDeletedParams>
 */
export function wixCliFileFolderCreatedRenamedDeleted(params: wixCliFileFolderCreatedRenamedDeletedParams): LogObject<wixCliFileFolderCreatedRenamedDeletedParams> {
  return { evid: 5202, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliCodeHasBeenChanged' event (evid: 5203)
 *
 * Event description: Sent when the user changes their code while Wix CLI is running (per local save)
 *
 * @param {wixCliCodeHasBeenChangedParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the command was entered
 * @property {boolean} isCI - Should be true if was fired from a CI environment
 * @property {string} nodeVersion - Which Node (full) version is being used
 * @property {string} cliVersion - The CLI version
 * @property {string} fileName - Full path of file (e.g. "public/pages/lkrir.js")
 * @property {string} shellVersion - Which version of the shell is being used
 * @property {string} shellName - Which shell is being used
 * @property {string} flow - "Sites"/"Apps"
 * @property {string} terminalVersion - Which version of the terminal is being used
 * @property {number} siteRevision - Site revision
 * @property {string} osName - Which OS is being used
 * @property {string} terminalName - Which terminal is being used
 * @property {string} osVersion - Which version of the OS is being used
 * @property {GUID} cliSessionID - A unique ID for each Wix dev session
 * @property {string} environment - the environment used (picasso/local computer etc)
 * @property {string} tracking_id - guid for tracking a single dev machine
 * @return {LogObject<wixCliCodeHasBeenChangedParams>} LogObject<wixCliCodeHasBeenChangedParams>
 */
export function wixCliCodeHasBeenChanged(params: wixCliCodeHasBeenChangedParams): LogObject<wixCliCodeHasBeenChangedParams> {
  return { evid: 5203, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliCliMessageDisplayed' event (evid: 5204)
 *
 * Event description: Sent when the Wix CLI presents a message to the user (e.g. after the editor disconnects)
 *
 * @param {wixCliCliMessageDisplayedParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the command was entered
 * @property {boolean} isCI - Should be true if was fired from a CI environment
 * @property {string} nodeVersion - Which Node (full) version is being used
 * @property {string} cliVersion - The CLI version
 * @property {string} shellVersion - Which version of the shell is being used
 * @property {string} shellName - Which shell is being used
 * @property {string} flow - "Sites"/"Apps"
 * @property {string} terminalVersion - Which version of the terminal is being used
 * @property {number} siteRevision - (Optional) Site revision, if available
 * @property {GUID} messageId - A unique ID for each message displayed
 * @property {string} osName - Which OS is being used
 * @property {string} message - The message that the CLI displays to the user
 * @property {string} terminalName - Which terminal is being used
 * @property {string} osVersion - Which version of the OS is being used
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @property {string} environment - the environment used (picasso/local computer etc)
 * @property {string} tracking_id - guid for tracking a single dev machine
 * @return {LogObject<wixCliCliMessageDisplayedParams>} LogObject<wixCliCliMessageDisplayedParams>
 */
export function wixCliCliMessageDisplayed(params: wixCliCliMessageDisplayedParams): LogObject<wixCliCliMessageDisplayedParams> {
  return { evid: 5204, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliUserResponseToCliMessage' event (evid: 5205)
 *
 * Event description: Sent when the user responds to a message presented by the CLI
 *
 * @param {wixCliUserResponseToCliMessageParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the command was entered
 * @property {boolean} isCI - Should be true if was fired from a CI environment
 * @property {string} nodeVersion - The Node (full) version
 * @property {string} cliVersion - The CLI version
 * @property {string} shellVersion - The shell version
 * @property {string} shellName - The shell that is being used
 * @property {string} flow - "Sites"/"Apps"
 * @property {string} terminalVersion - The terminal version
 * @property {number} siteRevision - (Optional) Site revision, if available
 * @property {GUID} messageId - A unique ID for each message displayed
 * @property {string} osName - The OS that is being used
 * @property {string} message - The message that the CLI displays to the user
 * @property {string} terminalName - The terminal that is being used
 * @property {string} osVersion - The version of the OS that is being used
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @property {string} action - The action performed by the user
 * @property {string} environment - the environment used (picasso/local computer etc)
 * @property {string} tracking_id - guid for tracking a single dev machine
 * @return {LogObject<wixCliUserResponseToCliMessageParams>} LogObject<wixCliUserResponseToCliMessageParams>
 */
export function wixCliUserResponseToCliMessage(params: wixCliUserResponseToCliMessageParams): LogObject<wixCliUserResponseToCliMessageParams> {
  return { evid: 5205, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliReadyForReloadAfterCodeChange' event (evid: 5206)
 *
 * Event description: Sent when Wix CLI is ready to reload the page after it has detected the user has changed code in the project
 *
 * @param {wixCliReadyForReloadAfterCodeChangeParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the command was entered
 * @property {boolean} isCI - Should be true if was fired from a CI environment
 * @property {number} duration - Time it took for Wix CLI to be ready to load the page after the code change (in ms)
 * @property {string} nodeVersion - The Node (full) version
 * @property {string} cliVersion - The CLI version
 * @property {string} fileName - Full path of file (e.g. "public/pages/lkrir.js")
 * @property {string} shellVersion - The shell version
 * @property {string} shellName - Which shell is being used
 * @property {string} flow - "Sites"/"Apps"
 * @property {string} terminalVersion - The terminal version
 * @property {number} siteRevision - Site revision
 * @property {string} osName - Which OS is being used
 * @property {string} terminalName - Which terminal is being used
 * @property {string} osVersion - The OS version
 * @property {GUID} cliSessionID - A unique ID for each Wix dev session
 * @property {string} environment - the environment used (picasso/local computer etc)
 * @property {string} tracking_id - guid for tracking a single dev machine
 * @return {LogObject<wixCliReadyForReloadAfterCodeChangeParams>} LogObject<wixCliReadyForReloadAfterCodeChangeParams>
 */
export function wixCliReadyForReloadAfterCodeChange(params: wixCliReadyForReloadAfterCodeChangeParams): LogObject<wixCliReadyForReloadAfterCodeChangeParams> {
  return { evid: 5206, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowFileUploadStarted' event (evid: 5208)
 *
 * Event description: Sent when the hosting service starts uploading files required by an app
 *
 * @param {wixCliAppFlowFileUploadStartedParams} params - The parameters for this event
 * @property {number} numFiles - How many files are uploaded
 * @property {string} projectId - The project that the users is currently working on
 * @property {number} fileSizeNotCompressed - The total size of the uploaded files
 * @property {string} hostingProvider - The hosting provider ("Wix"/...)
 * @property {number} timestampMs - The event's start time
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @property {number} fileSizeCompressed - The total size of the uploaded files, compressed
 * @property {string} cliVersion - The CLI version
 * @property {number} totalSizeKb - Use this field from cli version 1.1.41, until then use file_size_not_compressed
 * @property {string} flow - "Sites"/"Apps"
 * @property {string} environment - the environment used (picasso/local computer etc)
 * @property {string} tracking_id - guid for tracking a single dev machine
 * @return {LogObject<wixCliAppFlowFileUploadStartedParams>} LogObject<wixCliAppFlowFileUploadStartedParams>
 */
export function wixCliAppFlowFileUploadStarted(params: wixCliAppFlowFileUploadStartedParams): LogObject<wixCliAppFlowFileUploadStartedParams> {
  return { evid: 5208, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowZipUploadDone' event (evid: 5209)
 *
 * Event description: Sent when the hosting service is done uploading the zip
 *
 * @param {wixCliAppFlowZipUploadDoneParams} params - The parameters for this event
 * @property {number} duration - How much time it took to to upload the zip (in ms)
 * @property {string} projectId - The project that the users is currently working on
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @return {LogObject<wixCliAppFlowZipUploadDoneParams>} LogObject<wixCliAppFlowZipUploadDoneParams>
 */
export function wixCliAppFlowZipUploadDone(params: wixCliAppFlowZipUploadDoneParams): LogObject<wixCliAppFlowZipUploadDoneParams> {
  return { evid: 5209, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowUploadEnded' event (evid: 5210)
 *
 * Event description: Sent when the hosting service is done with the entire upload of the files
 *
 * @param {wixCliAppFlowUploadEndedParams} params - The parameters for this event
 * @property {number} duration - How much time it took for the entire upload (in ms)
 * @property {string} projectId - The project that the users is currently working on
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @property {string} cliVersion - The cli version
 * @property {string} flow - "Sites"/"Apps"
 * @property {string} environment - the environment used (picasso/local computer etc)
 * @property {string} tracking_id - guid for tracking a single dev machine
 * @return {LogObject<wixCliAppFlowUploadEndedParams>} LogObject<wixCliAppFlowUploadEndedParams>
 */
export function wixCliAppFlowUploadEnded(params: wixCliAppFlowUploadEndedParams): LogObject<wixCliAppFlowUploadEndedParams> {
  return { evid: 5210, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliLoginStart' event (evid: 5211)
 *
 * Event description: Sent when the Wix CLI authentication flow starts
 *
 * @param {wixCliLoginStartParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the command was entered
 * @property {boolean} wasLoggedIn - Was the user logged in before; i.e. did the user log out before starting the login process
 * @property {number} try - Which login is this - if 0, first try; if > 0, then this is a retry
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @property {string} flow - "Sites"/"Apps"
 * @property {string} environment - the environment used (picasso/local computer etc)
 * @property {string} tracking_id - guid for tracking a single dev machine
 * @return {LogObject<wixCliLoginStartParams>} LogObject<wixCliLoginStartParams>
 */
export function wixCliLoginStart(params: wixCliLoginStartParams): LogObject<wixCliLoginStartParams> {
  return { evid: 5211, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliLoginEnd' event (evid: 5212)
 *
 * Event description: Sent when the Wix CLI authentication flow ends
 *
 * @param {wixCliLoginEndParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the command was entered
 * @property {number} try - Which login is this - if 0, first try; if > 0, then this is a retry
 * @property {string} errorMessage - (Optional) The error message displayed, if the login was unsuccessul
 * @property {boolean} isSuccess - Was the login successful
 * @property {string} errorType - (Optional) The error type, if the login was unsuccessful
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @property {string} flow - "Sites"/"Apps"
 * @property {string} environment - the environment used (picasso/local computer etc)
 * @property {string} tracking_id - guid for tracking a single dev machine
 * @return {LogObject<wixCliLoginEndParams>} LogObject<wixCliLoginEndParams>
 */
export function wixCliLoginEnd(params: wixCliLoginEndParams): LogObject<wixCliLoginEndParams> {
  return { evid: 5212, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowAppGenerationTypeOfCreationSelected' event (evid: 5213)
 *
 * Event description: Sent when the user selects whether they would like to create a new Wix app or extend an existing one
 *
 * @param {wixCliAppFlowAppGenerationTypeOfCreationSelectedParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the command was entered
 * @property {string} projectId - The project that the users is currently working on
 * @property {string} type - What would the user like to create: a new Wix app, or add new extensions to an existing app
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @return {LogObject<wixCliAppFlowAppGenerationTypeOfCreationSelectedParams>} LogObject<wixCliAppFlowAppGenerationTypeOfCreationSelectedParams>
 */
export function wixCliAppFlowAppGenerationTypeOfCreationSelected(params: wixCliAppFlowAppGenerationTypeOfCreationSelectedParams): LogObject<wixCliAppFlowAppGenerationTypeOfCreationSelectedParams> {
  return { evid: 5213, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowAppGenerationNewAppNameEntered' event (evid: 5214)
 *
 * Event description: Sent when the user enters the name of the new app they want to create
 *
 * @param {wixCliAppFlowAppGenerationNewAppNameEnteredParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the command was entered
 * @property {string} name - Name of the new Wix App the user wants to create
 * @property {string} projectId - The project that the users is currently working on
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @return {LogObject<wixCliAppFlowAppGenerationNewAppNameEnteredParams>} LogObject<wixCliAppFlowAppGenerationNewAppNameEnteredParams>
 */
export function wixCliAppFlowAppGenerationNewAppNameEntered(params: wixCliAppFlowAppGenerationNewAppNameEnteredParams): LogObject<wixCliAppFlowAppGenerationNewAppNameEnteredParams> {
  return { evid: 5214, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowAppGenerationNewAppRegistrationEnd' event (evid: 5215)
 *
 * Event description: Sent when the new app registration ends (successfully or not)
 *
 * @param {wixCliAppFlowAppGenerationNewAppRegistrationEndParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the command was entered
 * @property {string} errorMessage - (Optional) If the registration was unsuccessful, the error message displayed to the user
 * @property {string} result - Was the app registration in the Dev Center successful or not
 * @property {string} projectId - The project that the users is currently working on
 * @property {string} errorType - (Optional) If the registration was unsuccessful, the error type
 * @property {string} appId - ID of the newly created Wix App
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @return {LogObject<wixCliAppFlowAppGenerationNewAppRegistrationEndParams>} LogObject<wixCliAppFlowAppGenerationNewAppRegistrationEndParams>
 */
export function wixCliAppFlowAppGenerationNewAppRegistrationEnd(params: wixCliAppFlowAppGenerationNewAppRegistrationEndParams): LogObject<wixCliAppFlowAppGenerationNewAppRegistrationEndParams> {
  return { evid: 5215, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowAppGenerationExistingAppSelected' event (evid: 5216)
 *
 * Event description: Sent when the user selects an existing app they want to extend
 *
 * @param {wixCliAppFlowAppGenerationExistingAppSelectedParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the command was entered
 * @property {string} appName - Name of the existing Wix App the user wants to extend
 * @property {string} projectId - The project that the users is currently working on
 * @property {number} numApps - How many apps does the user have
 * @property {string} appId - ID of the existing Wix App the user wants to extend
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @return {LogObject<wixCliAppFlowAppGenerationExistingAppSelectedParams>} LogObject<wixCliAppFlowAppGenerationExistingAppSelectedParams>
 */
export function wixCliAppFlowAppGenerationExistingAppSelected(params: wixCliAppFlowAppGenerationExistingAppSelectedParams): LogObject<wixCliAppFlowAppGenerationExistingAppSelectedParams> {
  return { evid: 5216, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowAppGenerationAppGenerationEnd' event (evid: 5217)
 *
 * Event description: Sent when the new app generation end (successfully or not)
 *
 * @param {wixCliAppFlowAppGenerationAppGenerationEndParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the command was entered
 * @property {string} errorMessage - (Optional) If the generation was unsuccessful, the error message displayed to the user
 * @property {string} result - Was the app folder generation successful or not
 * @property {string} projectId - The project that the users is currently working on
 * @property {string} errorType - (Optional) If the generation was unsuccessful, the error type
 * @property {string} failedStep - (Optional) If the generation was unsuccessful, which step failed
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @return {LogObject<wixCliAppFlowAppGenerationAppGenerationEndParams>} LogObject<wixCliAppFlowAppGenerationAppGenerationEndParams>
 */
export function wixCliAppFlowAppGenerationAppGenerationEnd(params: wixCliAppFlowAppGenerationAppGenerationEndParams): LogObject<wixCliAppFlowAppGenerationAppGenerationEndParams> {
  return { evid: 5217, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowComponentInstalledInTheApp' event (evid: 5218)
 *
 * Event description: Sent the components installed in the app when the app is published.
 *
 * @param {wixCliAppFlowComponentInstalledInTheAppParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the component was published
 * @property {string} cliVersion - The CLI version
 * @property {string} appCurrentVersion - The app version
 * @property {string} componentId - The Component Id
 * @property {string} projectId - The project that the users is currently working on
 * @property {string} widgetType - Relevant only for component type = widget. Pushed / Asked
 * @property {string} componentType - widget, page, sidebar category
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @return {LogObject<wixCliAppFlowComponentInstalledInTheAppParams>} LogObject<wixCliAppFlowComponentInstalledInTheAppParams>
 */
export function wixCliAppFlowComponentInstalledInTheApp(params: wixCliAppFlowComponentInstalledInTheAppParams): LogObject<wixCliAppFlowComponentInstalledInTheAppParams> {
  return { evid: 5218, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowDevelopmentSiteSiteSelectorOpened' event (evid: 5219)
 *
 * Event description: Sent when the sites selector is open
 *
 * @param {wixCliAppFlowDevelopmentSiteSiteSelectorOpenedParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the component was published
 * @property {number} devSitesLimit - How many development sites CAN the user have
 * @property {string} projectId - The project that the users is currently working on
 * @property {GUID} siteSelectorSessionId - A unique ID for each Site Selector session
 * @property {string} origin - From where did the user get to the Development Site Selector
 * @property {number} devSitesCount - How many development sites does the user currently have
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @return {LogObject<wixCliAppFlowDevelopmentSiteSiteSelectorOpenedParams>} LogObject<wixCliAppFlowDevelopmentSiteSiteSelectorOpenedParams>
 */
export function wixCliAppFlowDevelopmentSiteSiteSelectorOpened(params: wixCliAppFlowDevelopmentSiteSiteSelectorOpenedParams): LogObject<wixCliAppFlowDevelopmentSiteSiteSelectorOpenedParams> {
  return { evid: 5219, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowDevelopmentSiteTypeOfDevelopmentSiteSelected' event (evid: 5220)
 *
 * Event description: Sent when a site was selected at the sites selector
 *
 * @param {wixCliAppFlowDevelopmentSiteTypeOfDevelopmentSiteSelectedParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the component was published
 * @property {string} projectId - The project that the users is currently working on
 * @property {GUID} siteSelectorSessionId - A unique ID for each Site Selector session
 * @property {string} type - Would the user like to create a new development site or pick an existing one
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @return {LogObject<wixCliAppFlowDevelopmentSiteTypeOfDevelopmentSiteSelectedParams>} LogObject<wixCliAppFlowDevelopmentSiteTypeOfDevelopmentSiteSelectedParams>
 */
export function wixCliAppFlowDevelopmentSiteTypeOfDevelopmentSiteSelected(params: wixCliAppFlowDevelopmentSiteTypeOfDevelopmentSiteSelectedParams): LogObject<wixCliAppFlowDevelopmentSiteTypeOfDevelopmentSiteSelectedParams> {
  return { evid: 5220, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowDevelopmentSiteNewDevelopmentSiteCreationStart' event (evid: 5221)
 *
 * Event description: Sent when a New Development Site Creation Starts
 *
 * @param {wixCliAppFlowDevelopmentSiteNewDevelopmentSiteCreationStartParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the component was published
 * @property {string} projectId - The project that the users is currently working on
 * @property {GUID} siteSelectorSessionId - A unique ID for each Site Selector session
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @return {LogObject<wixCliAppFlowDevelopmentSiteNewDevelopmentSiteCreationStartParams>} LogObject<wixCliAppFlowDevelopmentSiteNewDevelopmentSiteCreationStartParams>
 */
export function wixCliAppFlowDevelopmentSiteNewDevelopmentSiteCreationStart(params: wixCliAppFlowDevelopmentSiteNewDevelopmentSiteCreationStartParams): LogObject<wixCliAppFlowDevelopmentSiteNewDevelopmentSiteCreationStartParams> {
  return { evid: 5221, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowDevelopmentSiteNewDevelopmentSiteCreationEnd' event (evid: 5222)
 *
 * Event description: Sent when a New Development Site Creation Ends
 *
 * @param {wixCliAppFlowDevelopmentSiteNewDevelopmentSiteCreationEndParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the component was published
 * @property {string} errorMessage - (Optional) If the site creation was unsuccessful, the error message displayed to the user
 * @property {string} result - Was the new site creation successful or not
 * @property {string} projectId - The project that the users is currently working on
 * @property {GUID} siteSelectorSessionId - A unique ID for each Site Selector session
 * @property {string} errorType - (Optional) If the site creation was unsuccessful, the error type
 * @property {string} siteName - (Optional) Name of the newly created development site
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @property {GUID} msid - The site's ID
 * @property {string} siteUrl - (Optional) URL of the newly created development site
 * @return {LogObject<wixCliAppFlowDevelopmentSiteNewDevelopmentSiteCreationEndParams>} LogObject<wixCliAppFlowDevelopmentSiteNewDevelopmentSiteCreationEndParams>
 */
export function wixCliAppFlowDevelopmentSiteNewDevelopmentSiteCreationEnd(params: wixCliAppFlowDevelopmentSiteNewDevelopmentSiteCreationEndParams): LogObject<wixCliAppFlowDevelopmentSiteNewDevelopmentSiteCreationEndParams> {
  return { evid: 5222, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowDevelopmentSiteExistingSiteSelected' event (evid: 5223)
 *
 * Event description: Sent when an Existing site was selected
 *
 * @param {wixCliAppFlowDevelopmentSiteExistingSiteSelectedParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the component was published
 * @property {string} projectId - The project that the users is currently working on
 * @property {GUID} siteSelectorSessionId - A unique ID for each Site Selector session
 * @property {string} siteName - (Optional) Name of the newly created development site
 * @property {number} numSites - How many sites does the user have (>=1)
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @property {GUID} msid - The site's ID
 * @property {string} siteUrl - (Optional) URL of the newly created development site
 * @return {LogObject<wixCliAppFlowDevelopmentSiteExistingSiteSelectedParams>} LogObject<wixCliAppFlowDevelopmentSiteExistingSiteSelectedParams>
 */
export function wixCliAppFlowDevelopmentSiteExistingSiteSelected(params: wixCliAppFlowDevelopmentSiteExistingSiteSelectedParams): LogObject<wixCliAppFlowDevelopmentSiteExistingSiteSelectedParams> {
  return { evid: 5223, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowDevelopmentSiteAppInstallationOnDevelopmentSiteStart' event (evid: 5224)
 *
 * Event description: Sent when an App Installation on Development Site Starts
 *
 * @param {wixCliAppFlowDevelopmentSiteAppInstallationOnDevelopmentSiteStartParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the component was published
 * @property {string} appName - Name of the Wix App the user wants to install
 * @property {string} projectId - The project that the users is currently working on
 * @property {GUID} siteSelectorSessionId - A unique ID for each Site Selector session
 * @property {GUID} appId - ID of the Wix App the user wants to install
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @property {GUID} msid - The site's ID
 * @return {LogObject<wixCliAppFlowDevelopmentSiteAppInstallationOnDevelopmentSiteStartParams>} LogObject<wixCliAppFlowDevelopmentSiteAppInstallationOnDevelopmentSiteStartParams>
 */
export function wixCliAppFlowDevelopmentSiteAppInstallationOnDevelopmentSiteStart(params: wixCliAppFlowDevelopmentSiteAppInstallationOnDevelopmentSiteStartParams): LogObject<wixCliAppFlowDevelopmentSiteAppInstallationOnDevelopmentSiteStartParams> {
  return { evid: 5224, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowDevelopmentSiteAppInstallationOnDevelopmentSiteEnd' event (evid: 5225)
 *
 * Event description: Sent when an App Installation on Development Site Ends
 *
 * @param {wixCliAppFlowDevelopmentSiteAppInstallationOnDevelopmentSiteEndParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the component was published
 * @property {string} errorMessage - (Optional) If the app installation on the site was unsuccessful, the error message displayed to the user
 * @property {string} result - Was the app successfully installed on the development site or not
 * @property {string} projectId - The project that the users is currently working on
 * @property {GUID} siteSelectorSessionId - A unique ID for each Site Selector session
 * @property {string} errorType - (Optional) If the site installation on the site was unsuccessful, the error type
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @property {GUID} msid - The site's ID
 * @return {LogObject<wixCliAppFlowDevelopmentSiteAppInstallationOnDevelopmentSiteEndParams>} LogObject<wixCliAppFlowDevelopmentSiteAppInstallationOnDevelopmentSiteEndParams>
 */
export function wixCliAppFlowDevelopmentSiteAppInstallationOnDevelopmentSiteEnd(params: wixCliAppFlowDevelopmentSiteAppInstallationOnDevelopmentSiteEndParams): LogObject<wixCliAppFlowDevelopmentSiteAppInstallationOnDevelopmentSiteEndParams> {
  return { evid: 5225, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowDevelopmentSiteDevelopmentSiteSet' event (evid: 5226)
 *
 * Event description: Sent when a development site was set
 *
 * @param {wixCliAppFlowDevelopmentSiteDevelopmentSiteSetParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the component was published
 * @property {string} projectId - The project that the users is currently working on
 * @property {GUID} siteSelectorSessionId - A unique ID for each Site Selector session
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @property {GUID} msid - The site's ID
 * @return {LogObject<wixCliAppFlowDevelopmentSiteDevelopmentSiteSetParams>} LogObject<wixCliAppFlowDevelopmentSiteDevelopmentSiteSetParams>
 */
export function wixCliAppFlowDevelopmentSiteDevelopmentSiteSet(params: wixCliAppFlowDevelopmentSiteDevelopmentSiteSetParams): LogObject<wixCliAppFlowDevelopmentSiteDevelopmentSiteSetParams> {
  return { evid: 5226, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowDevelopmentSiteSiteSelectorAborted' event (evid: 5227)
 *
 * Event description: Sent when there was a Site Selector Abort
 *
 * @param {wixCliAppFlowDevelopmentSiteSiteSelectorAbortedParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the component was published
 * @property {string} projectId - The project that the users is currently working on
 * @property {GUID} siteSelectorSessionId - A unique ID for each Site Selector session
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @return {LogObject<wixCliAppFlowDevelopmentSiteSiteSelectorAbortedParams>} LogObject<wixCliAppFlowDevelopmentSiteSiteSelectorAbortedParams>
 */
export function wixCliAppFlowDevelopmentSiteSiteSelectorAborted(params: wixCliAppFlowDevelopmentSiteSiteSelectorAbortedParams): LogObject<wixCliAppFlowDevelopmentSiteSiteSelectorAbortedParams> {
  return { evid: 5227, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowExtensionGenerationExtensionWasAdded' event (evid: 5228)
 *
 * Event description: Sent the Extension generated in the app when the generate session is finished.
 *
 * @param {wixCliAppFlowExtensionGenerationExtensionWasAddedParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the component was published
 * @property {string} failureReason - The failure reason, will be null if the extension was added successfully
 * @property {string} cliVersion - The CLI version
 * @property {string} appCurrentVersion - The app version
 * @property {string} componentId - The Component Id
 * @property {string} projectId - The project that the users is currently working on
 * @property {string} widgetType - Relevant only for component type = widget. Pushed / Asked
 * @property {string} componentType - widget, page, sidebar category
 * @property {boolean} wasSuccess - True if the extension was added successfully
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @return {LogObject<wixCliAppFlowExtensionGenerationExtensionWasAddedParams>} LogObject<wixCliAppFlowExtensionGenerationExtensionWasAddedParams>
 */
export function wixCliAppFlowExtensionGenerationExtensionWasAdded(params: wixCliAppFlowExtensionGenerationExtensionWasAddedParams): LogObject<wixCliAppFlowExtensionGenerationExtensionWasAddedParams> {
  return { evid: 5228, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowStepsAnswers' event (evid: 5229)
 *
 * Event description: Sent on each answer the user writes, on each step of the flow.  (answers for CLI questions)
 *
 * @param {wixCliAppFlowStepsAnswersParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the component was published
 * @property {string} question - The question that the user is answering on
 * @property {string} cliVersion - The CLI version
 * @property {string} appCurrentVersion - The app version
 * @property {string} projectId - The project that the users is currently working on
 * @property {string} command - The command that the user is working on now
 * @property {string} answer - The answer that the user wrote
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @property {string} environment - the environment used (picasso/local computer etc)
 * @property {string} flow - Apps / Sites
 * @property {string} arguments - Additional data - for example the template name
 * @property {string} additionalInfo - Any additional info needed in Json - {extensionType:”...”, extensionGroup:”...”, etc…}.
 * extensionType - dashboard page / side bar category / specific-ecomm-checkout-plugin / etc.. (relevant only for Existing app extension flow)
 * extensionGroup - Dashboard / site / backend
 * @property {string} questionKey - constant id for each question
 * @property {string} tracking_id - Tracking ID for the CLI session flow
 * @return {LogObject<wixCliAppFlowStepsAnswersParams>} LogObject<wixCliAppFlowStepsAnswersParams>
 */
export function wixCliAppFlowStepsAnswers(params: wixCliAppFlowStepsAnswersParams): LogObject<wixCliAppFlowStepsAnswersParams> {
  return { evid: 5229, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliCliError' event (evid: 5230)
 *
 * Event description: Sent when there is a user/ system error at the CLI
 *
 * @param {wixCliCliErrorParams} params - The parameters for this event
 * @property {DateTime} localTime - The local time during which the error happened
 * @property {string} errorMessage - (Optional) The error message displayed, if the command was invalid
 * @property {string} projectId - The project id that the dev is currently working on
 * @property {string} errorType - (Optional) The error type, if the command was invalid - User/ System error
 * @property {string} errorName - The error name - a generic name for a group off errors. (Optional) if the command was invalid
 * @property {GUID} cliSessionId - A unique ID for each Wix dev session
 * @property {string} flow - "Sites"/"Apps"
 * @property {string} environment - the environment used (picasso/local computer etc)
 * @property {string} tracking_id - guid for tracking a single dev machine
 * @return {LogObject<wixCliCliErrorParams>} LogObject<wixCliCliErrorParams>
 */
export function wixCliCliError(params: wixCliCliErrorParams): LogObject<wixCliCliErrorParams> {
  return { evid: 5230, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAction' event (evid: 5231)
 *
 * Event description: Sent on each key press the user presses on at the CLI flow. For example - Enter to install an app / esc.
 *
 * @param {wixCliActionParams} params - The parameters for this event
 * @property {DateTime} localTime - local_time
 * @property {string} question - The question that the user is answering on
 * @property {string} cliVersion - cli_version
 * @property {string} appCurrentVersion - app_current_version
 * @property {string} projectId - The project that the users is currently working on
 * @property {string} command - The command that the user is working on now
 * @property {string} action - The action that the user choose
 * @property {GUID} cliSessionId - cli_session_id
 * @property {string} key - The key that the user press on
 * @property {string} flow - Apps / Sites
 * @property {string} arguments - Additional data - for example the template name
 * @property {string} additionalInfo - Any additional info needed in Json - {extensionType:”...”, extensionGroup:”...”, etc…}.
 * extensionType - dashboard page / side bar category / specific-ecomm-checkout-plugin / etc.. (relevant only for Existing app extension flow)
 * extensionGroup - Dashboard / site / backend
 * @property {string} questionKey - constant id for each question
 * @property {string} environment - the environment used (picasso/local computer etc)
 * @property {string} tracking_id - guid for tracking a single dev machine
 * @return {LogObject<wixCliActionParams>} LogObject<wixCliActionParams>
 */
export function wixCliAction(params: wixCliActionParams): LogObject<wixCliActionParams> {
  return { evid: 5231, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppsFlowDeploymentStatusSrc11Evid5232' event (evid: 5232)
 *
 * Event description: The event will be sent when a deployment is finished (from appCloud/Cloudflare).
 *
 *
 * @param {wixCliAppsFlowDeploymentStatusSrc11Evid5232Params} params - The parameters for this event
 * @property {string} filesDetails -  [{file type: Number_files, file type: Number_files, etc..}]
 * @property {boolean} isSuccess - True if the deployment finished successfully
 * @property {string} failureReason - The failure reason, can be null
 * @property {string} uploadSource - appCloud / Cloudflare
 * @property {GUID} appId - the app id
 * @property {string} deploymentId - deploymentId
 * @property {GUID} cliSessionId - the cli session id
 * @property {number} filesSize - Total size of all files in the deployment - kb
 * @property {number} filesUploadTime - the filesUploadTime in ms
 * @property {string} flow - "Sites"/"Apps"
 * @property {string} environment - the environment used (picasso/local computer etc)
 * @property {string} tracking_id - guid for tracking a single dev machine
 * @return {LogObject<wixCliAppsFlowDeploymentStatusSrc11Evid5232Params>} LogObject<wixCliAppsFlowDeploymentStatusSrc11Evid5232Params>
 */
export function wixCliAppsFlowDeploymentStatusSrc11Evid5232(params: wixCliAppsFlowDeploymentStatusSrc11Evid5232Params): LogObject<wixCliAppsFlowDeploymentStatusSrc11Evid5232Params> {
  return { evid: 5232, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppsFlowTunnelCreationStatusSrc11Evid5233' event (evid: 5233)
 *
 * Event description: The event will be sent when the dev command is in action - when the tunnel is being connected so the user will have a connection between Wix to his local server.
 *
 *
 *
 * @param {wixCliAppsFlowTunnelCreationStatusSrc11Evid5233Params} params - The parameters for this event
 * @property {boolean} isSuccess - True if the deployment finished successfully
 * @property {string} failureReason - The failure reason, can be null
 * @property {GUID} cliSessionId - the cli session id
 * @property {GUID} appId - the app id
 * @property {number} tunnelCreationTime - in ms
 * @property {string} flow - "Sites"/"Apps"
 * @property {string} environment - the environment used (picasso/local computer etc)
 * @property {string} tracking_id - guid for tracking a single dev machine
 * @return {LogObject<wixCliAppsFlowTunnelCreationStatusSrc11Evid5233Params>} LogObject<wixCliAppsFlowTunnelCreationStatusSrc11Evid5233Params>
 */
export function wixCliAppsFlowTunnelCreationStatusSrc11Evid5233(params: wixCliAppsFlowTunnelCreationStatusSrc11Evid5233Params): LogObject<wixCliAppsFlowTunnelCreationStatusSrc11Evid5233Params> {
  return { evid: 5233, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppsFlowDeploymentRequestSrc11Evid5234' event (evid: 5234)
 *
 * Event description: The event will be sent when there is a deployment request - a friend opened the url I sent him / UoU using the app.
 *
 * @param {wixCliAppsFlowDeploymentRequestSrc11Evid5234Params} params - The parameters for this event
 * @property {string} appId - The id of the app that the deployment request was for
 * @property {string} deploymentId - deploymentId
 * @return {LogObject<wixCliAppsFlowDeploymentRequestSrc11Evid5234Params>} LogObject<wixCliAppsFlowDeploymentRequestSrc11Evid5234Params>
 */
export function wixCliAppsFlowDeploymentRequestSrc11Evid5234(params: wixCliAppsFlowDeploymentRequestSrc11Evid5234Params): LogObject<wixCliAppsFlowDeploymentRequestSrc11Evid5234Params> {
  return { evid: 5234, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wixCliAppFlowAppCloudServerUploadedSrc11Evid5235' event (evid: 5235)
 *
 * Event description: The event will be sent when a server uploaded is finished - successfully / not.
 *
 * @param {wixCliAppFlowAppCloudServerUploadedSrc11Evid5235Params} params - The parameters for this event
 * @property {string} deploymentId - The deployment id
 * @property {boolean} wasSuccess - True if the upload succeeded
 * @property {string} location - S3 or MediaPlatform
 * @property {string} uploadUrl - The url that was uploaded - created for s3
 * @property {string} appId - The app id
 * @property {string} fields - Uploaded destination details
 * @property {string} serveUrl - the serveUrl - created for wix servers
 * @property {string} uploadStatus - The uploaded start/end
 * @property {string} fileUrl - The file url
 * @property {DateTime} localTime - the local time when the uploaded started / ended
 * @return {LogObject<wixCliAppFlowAppCloudServerUploadedSrc11Evid5235Params>} LogObject<wixCliAppFlowAppCloudServerUploadedSrc11Evid5235Params>
 */
export function wixCliAppFlowAppCloudServerUploadedSrc11Evid5235(params: wixCliAppFlowAppCloudServerUploadedSrc11Evid5235Params): LogObject<wixCliAppFlowAppCloudServerUploadedSrc11Evid5235Params> {
  return { evid: 5235, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'arkSlackAlertSent' event (evid: 5500)
 *
 * Event description: Reports each time Ark detects an issue with the gradual rollout process and sends an alert to the relevant Slack channel
 *
 * @param {arkSlackAlertSentParams} params - The parameters for this event
 * @property {string} artifactId - The artifact that is being rolled out
 * @property {string} step - On which step was the rollout before being stopped
 * @property {number} alertTimeout - How much time (in ms) is the alert supposed to be displayed before the rollout is automatically stopped
 * @property {string} exposure - To how many users was the rollout exposed before being stopped
 * @property {string} version - Which version is being rolled out
 * @property {number} numAlerts - How many alerts were detected by Ark
 * @property {string} messageId - A unique ID per alert
 * @property {string} rolloutId - A unique ID per rollout
 * @property {string} mode - "Auto"/"Manual"
 * @property {number} timestampMs - The event's creation time
 * @property {string} slackChannel - To which slack channel is the alert sent
 * @property {string} artifactType - The artifact type (FULLSTACK/SERVER/STATIC)
 * @return {LogObject<arkSlackAlertSentParams>} LogObject<arkSlackAlertSentParams>
 */
export function arkSlackAlertSent(params: arkSlackAlertSentParams): LogObject<arkSlackAlertSentParams> {
  return { evid: 5500, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'sledMergeQueueManualClickSrc11Evid90599' event (evid: 90599)
 *
 * Event description: Sent when the user click manually on merge queue
 *
 * @param {sledMergeQueueManualClickSrc11Evid90599Params} params - The parameters for this event
 * @property {string} pullRequestId - The pr id
 * @property {string} sledRunId - The sled run id (to know the sled run result)
 * @property {string} repoName - The repo name
 * @return {LogObject<sledMergeQueueManualClickSrc11Evid90599Params>} LogObject<sledMergeQueueManualClickSrc11Evid90599Params>
 */
export function sledMergeQueueManualClickSrc11Evid90599(params: sledMergeQueueManualClickSrc11Evid90599Params): LogObject<sledMergeQueueManualClickSrc11Evid90599Params> {
  return { evid: 90599, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'sledMergeQueueRunSrc11Evid90600' event (evid: 90600)
 *
 * Event description: Sent when sled pr run starts and ends, when the run starts by merge queue
 *
 * @param {sledMergeQueueRunSrc11Evid90600Params} params - The parameters for this event
 * @property {string} sledRunId - The sled run id
 * @property {string} pullRequestId - The PR id
 * @property {string} allPrs - String of all the prs in the queue with the pr that the event is sent for: [{pr: MergeQueueEntryState, Position,SledRunId?},{ pr: MergeQueueEntryState,Position, SledRunId?} ..]
 * @property {number} position - The position of the pr in the queue (0,1,2,3..)
 * @property {string} mergeQueueEntryState - queued / waiting / blocked/ etc..
 * @property {string} sledPhase - Start / End
 * @property {string} repoName - The repo name
 * @property {string} fullBuildCountInPr - sled_build_count_in_pr
 * @property {string} buildId - buildId
 * @property {string} fingerprint - fingerprint
 * @return {LogObject<sledMergeQueueRunSrc11Evid90600Params>} LogObject<sledMergeQueueRunSrc11Evid90600Params>
 */
export function sledMergeQueueRunSrc11Evid90600(params: sledMergeQueueRunSrc11Evid90600Params): LogObject<sledMergeQueueRunSrc11Evid90600Params> {
  return { evid: 90600, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'perferRunStart' event (evid: 91200)
 *
 * Event description: Sent once Perfer starts a new run. 
 * Perfer is an automatic tool for measuring performance on a build level before it gets to production
 *
 * @param {perferRunStartParams} params - The parameters for this event
 * @property {string} package - package path
 * @property {DateTime} timestamp - timestamp of when the run started
 * @property {string} commit - commit hash
 * @property {string} branch - branch name
 * @property {GUID} run_id - run id
 * @property {string} repo - repository uri
 * @return {LogObject<perferRunStartParams>} LogObject<perferRunStartParams>
 */
export function perferRunStart(params: perferRunStartParams): LogObject<perferRunStartParams> {
  return { evid: 91200, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'perferRunFinished' event (evid: 91201)
 *
 * Event description: Sent once Perfer run finished. 
 * Perfer is an automatic tool for measuring performance on a build level before it gets to production.
 *
 * @param {perferRunFinishedParams} params - The parameters for this event
 * @property {number} test_case_fail_count - number of test cases failed on this run
 * @property {number} test_case_count - number of test cases ran on this run
 * @property {string} additional_info - free text for additional info
 * @property {GUID} run_id - run id
 * @property {string} run_result - success / fail / error (success if the run passed, fail if there is a performance issue and the run failed, error if the run didn't complete)
 * @return {LogObject<perferRunFinishedParams>} LogObject<perferRunFinishedParams>
 */
export function perferRunFinished(params: perferRunFinishedParams): LogObject<perferRunFinishedParams> {
  return { evid: 91201, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'perferTestCaseResult' event (evid: 91202)
 *
 * Event description: Sent for each Perfer test case. 
 * Perfer is an automatic tool for measuring performance on a build level before it gets to production.
 *
 * @param {perferTestCaseResultParams} params - The parameters for this event
 * @property {string} test_case_type - loading time / file size
 * @property {number} expected - expected result for this test case
 * @property {string} test_case_result - success / fail
 * @property {GUID} run_id - run id
 * @property {string} scenario_type - which version of the artifact we’re testing. E.g product page w/ or w/o button
 * @property {string} test_case_mark_type - e.g. beat 33
 * @property {number} actual - actual result measured on this test case
 * @return {LogObject<perferTestCaseResultParams>} LogObject<perferTestCaseResultParams>
 */
export function perferTestCaseResult(params: perferTestCaseResultParams): LogObject<perferTestCaseResultParams> {
  return { evid: 91202, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'perferRunResult' event (evid: 91204)
 *
 * Event description: Sent when a full Perfer run has ended -- this event is sent multiple times per perferRunId, as we don't really know when the run is over, there can only be retries. In order to get the latest result, we will look at the most current data per perferRunId.
 *
 * @param {perferRunResultParams} params - The parameters for this event
 * @property {string} artifactId - For which artifact did Perfer run
 * @property {string} fingerprint - The build’s unique fingerprint
 * @property {number} numRules - How many rules/violations were tested in this run
 * @property {string} perferReqId - A changing ID - there can be several such IDs per perferRunId. We use the newest one in order to know which metrics to take into consideration when calculating the success rate.
 * @property {string} result - “Passed”/”Failed”
 * @property {string} branch - Which branch is used
 * @property {string} perferRunId - Unique ID of Perfer request
 * @property {number} numRulesFailed - How many non Beta rules failed/violations were found in this run
 * @property {number} numBetaRulesFailed - How many Beta rules failed/violations were found in this run -- this number doesn't affect the result
 * @return {LogObject<perferRunResultParams>} LogObject<perferRunResultParams>
 */
export function perferRunResult(params: perferRunResultParams): LogObject<perferRunResultParams> {
  return { evid: 91204, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'perferMetricResult' event (evid: 91205)
 *
 * Event description: Sent when Perfer reports the result of a specific limit test in a benchmark
 *
 * @param {perferMetricResultParams} params - The parameters for this event
 * @property {string} thresholdType - “absolute”/”relative”
 * @property {string} metricUnit - Metric unit (eg: "seconds"/"kb")
 * @property {string} ruleOwner - “Wix”/”user”
 * @property {string} metricType - “mark”/”measure”/”customMetric”
 * @property {string} perferReqId - A changing ID - there can be several such IDs per perferRunId. We use the newest one in order to know which metrics to take into consideration when calculating the success rate.
 * @property {string} result - “Passed”/”Failed”
 * @property {string} maxAllowedDegradation - Maximum allowed change in value for benchmark (in percentage) - relevant for relative
 * @property {boolean} isBetaRule - Is this a Beta rule or not (Beta rule: We ignore its result when calculating the entire run result)
 * @property {string} metricName - Example: “full app render”/”react render”/”requestCountJs”
 * @property {string} fileName - For which file is this benchmark written
 * @property {string} perferRunId - Unique ID of Perfer request
 * @property {string} benchmarkName - Example: “my benchmark”
 * @property {string} comparisonObject - “lt”/”lte”/”gt”/”gte” - only if metricType = “customMetric” and developer explicitly set it
 * @property {string} environmentType - “Sled”/”FileStats”/”BundleStats”/”Android”/”iOS”/”Node”/”Browser”/”Lambda”/”SiteMetrics”
 * @property {string} validationType - "BenchmarkUserLimit"/"BundleDegradationFromUpstream"/"TransferSizeDegradationFromUpstreamDefault" -- and another few examples
 * @property {string} allowedValue - Maximum allowed value for benchmark - relevant for absolute + relative
 * @property {string} metricCategory - “Bundle Size”/”Browser Benchmarks”/”Lighthouse Benchmark”/”Others” -- derived from environmentType
 * @property {string} baselineValue - Latest master value
 * @property {string} actualValue - Actual calculated value
 * @return {LogObject<perferMetricResultParams>} LogObject<perferMetricResultParams>
 */
export function perferMetricResult(params: perferMetricResultParams): LogObject<perferMetricResultParams> {
  return { evid: 91205, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'perferTestStarted' event (evid: 91206)
 *
 * Event description: Sent when a Perfer test is started on the client side
 *
 * @param {perferTestStartedParams} params - The parameters for this event
 * @property {string} fingerprint - The build’s unique fingerprint
 * @property {string} branch - Which branch is used
 * @property {string} fileName - For which file is this benchmark written
 * @property {string} benchmarkName - Example: “my benchmark”
 * @property {string} version - Perfer version
 * @property {string} environmentType - “Sled”/”FileStats”/”BundleStats”/”Android”/”iOS”/”Node”/”Browser”/”Lambda”/”SiteMetrics”
 * @property {string} test_run_id - Unique ID of test
 * @property {string} metricCategory - “Bundle Size”/”Browser Benchmarks”/”Lighthouse Benchmarks”/”Others”
 * @return {LogObject<perferTestStartedParams>} LogObject<perferTestStartedParams>
 */
export function perferTestStarted(params: perferTestStartedParams): LogObject<perferTestStartedParams> {
  return { evid: 91206, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'perferTestEnded' event (evid: 91207)
 *
 * Event description: Sent when a Perfer test has ended on the client side
 *
 * @param {perferTestEndedParams} params - The parameters for this event
 * @property {string} fingerprint - The build’s unique fingerprint
 * @property {string} errorMessage - The error message displayed, if Perfer failed
 * @property {string} result - 'OK' | 'Runtime Error' | 'Validation Error' | 'Error
 * @property {string} branch - Which branch is used
 * @property {string} fileName - For which file is this benchmark written
 * @property {string} benchmarkName - Example: “my benchmark”
 * @property {string} version - Perfer version
 * @property {string} environmentType - “Sled”/”FileStats”/”BundleStats”/”Android”/”iOS”/”Node”/”Browser”/”Lambda”/”SiteMetrics”
 * @property {string} test_run_id - Unique ID of test
 * @property {string} metricCategory - “Bundle Size”/”Browser Benchmarks”/”Lighthouse Benchmarks”/”Others”
 * @return {LogObject<perferTestEndedParams>} LogObject<perferTestEndedParams>
 */
export function perferTestEnded(params: perferTestEndedParams): LogObject<perferTestEndedParams> {
  return { evid: 91207, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'perferReportOpened' event (evid: 91211)
 *
 * Event description: Sent when a Perfer report is opened by a user
 *
 * @param {perferReportOpenedParams} params - The parameters for this event
 * @property {string} artifactId - For which artifact did Perfer run
 * @property {string} fingerprint - The build’s unique fingerprint
 * @property {string} result - "Passed"/"Failed"
 * @property {string} branch - Which branch is used
 * @property {string} perferRunId - Unique ID of Perfer request
 * @property {string} urlOpened - The Perfer report URL
 * @property {number} numRulesFailed - How many non Beta rules failed/violations were found in this run
 * @return {LogObject<perferReportOpenedParams>} LogObject<perferReportOpenedParams>
 */
export function perferReportOpened(params: perferReportOpenedParams): LogObject<perferReportOpenedParams> {
  return { evid: 91211, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'perferClickOnResetArtifactSBaselineButton' event (evid: 91212)
 *
 * Event description: Sent when a user clicks the button titled “Reset artifact’s baseline” in Perfer report
 *
 * @param {perferClickOnResetArtifactSBaselineButtonParams} params - The parameters for this event
 * @property {string} artifactId - For which artifact did Perfer run
 * @property {string} perferRunId - Unique ID of Perfer request
 * @property {string} urlOpened - The Perfer report URL
 * @return {LogObject<perferClickOnResetArtifactSBaselineButtonParams>} LogObject<perferClickOnResetArtifactSBaselineButtonParams>
 */
export function perferClickOnResetArtifactSBaselineButton(params: perferClickOnResetArtifactSBaselineButtonParams): LogObject<perferClickOnResetArtifactSBaselineButtonParams> {
  return { evid: 91212, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'perferResetArtifactSBaseline' event (evid: 91213)
 *
 * Event description: Sent when a user clicks the button titled “I understand, commit baseline reset” in Perfer report
 *
 * @param {perferResetArtifactSBaselineParams} params - The parameters for this event
 * @property {string} artifactId - For which artifact did Perfer run
 * @property {string} perferRunId - Unique ID of Perfer request
 * @property {string} urlOpened - The Perfer report URL
 * @property {string} user - Which user opened the report
 * @return {LogObject<perferResetArtifactSBaselineParams>} LogObject<perferResetArtifactSBaselineParams>
 */
export function perferResetArtifactSBaseline(params: perferResetArtifactSBaselineParams): LogObject<perferResetArtifactSBaselineParams> {
  return { evid: 91213, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'buildStart' event (evid: 91400)
 *
 * Event description: Sent for each CI build start
 *
 * @param {buildStartParams} params - The parameters for this event
 * @property {boolean} isCI - Should be true if was fired from a CI environment
 * @property {string} projectName - The name of the project (name in package.json).
 * @property {number} nodeMajorVersion - The major version of Node used in the project.
 * @property {string} email - User email
 * @property {boolean} isMasterCi - TRUE if the CI run is on master; FALSE if PR or not CI run
 * @property {string} projectLanguage - The language used in the project. Can be either TS or JS.
 * @property {number} yoshiMajorVersion - The major version of Yoshi used in the project.
 * @property {string} yoshiFlow - Should return a string with the used yoshi flow (e.g. yoshi-flow-editor))
 * @property {string} yoshiVersion - The semver version of Yoshi used in the project.
 * @property {string} typescriptVersion - The typescript version used in the project.
 * @return {LogObject<buildStartParams>} LogObject<buildStartParams>
 */
export function buildStart(params: buildStartParams): LogObject<buildStartParams> {
  return { evid: 91400, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'startInit' event (evid: 91401)
 *
 * Event description: Track the "start" command init in yoshi projects
 *
 * @param {startInitParams} params - The parameters for this event
 * @property {boolean} isCI - Should be true if was fired from a CI environment
 * @property {string} projectName - The name of the project (name in package.json).
 * @property {number} nodeMajorVersion - The major version of Node used in the project.
 * @property {string} email - User email
 * @property {string} projectLanguage - The language used in the project. Can be either TS or JS.
 * @property {number} yoshiMajorVersion - The major version of Yoshi used in the project.
 * @property {string} yoshiFlow - Should return a string with the used yoshi flow (e.g. yoshi-flow-editor))
 * @property {string} yoshiVersion - The semver version of Yoshi used in the project.
 * @property {string} typescriptVersion - The TypeScript version used in the project.
 * @return {LogObject<startInitParams>} LogObject<startInitParams>
 */
export function startInit(params: startInitParams): LogObject<startInitParams> {
  return { evid: 91401, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'createProject' event (evid: 91402)
 *
 * Event description: Track newly generated project using create-yoshi-app
 *
 * @param {createProjectParams} params - The parameters for this event
 * @property {string} monorepoManagementTool - Monorepo management tool name (available when CYA running inside monorepo).
 * @property {string} projectName - The name of the project (name in package.json).
 * @property {string} email - User email
 * @property {string} templateName - The template chosen by the user
 * @property {string} projectLanguage - The language used in the project. Can be either TS or JS.
 * @property {boolean} isInsideMonorepo - Is CYA running in Yoshi supported monorepo.
 * @property {number} yoshiMajorVersion - The major version of Yoshi used in the project.
 * @property {string} yoshiVersion - The semver version of Yoshi used in the project.
 * @return {LogObject<createProjectParams>} LogObject<createProjectParams>
 */
export function createProject(params: createProjectParams): LogObject<createProjectParams> {
  return { evid: 91402, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'buildEnd' event (evid: 91403)
 *
 * Event description: Fired when a Yoshi CI build has finished and adds data related to it.
 *
 * @param {buildEndParams} params - The parameters for this event
 * @property {number} buildDuration - How long building took in seconds
 * @property {boolean} isCI - Should be true if was fired from a CI environment
 * @property {string} projectName - The name of the project (name in package.json).
 * @property {number} nodeMajorVersion - The major version of Node used in the project.
 * @property {string} email - User email
 * @property {boolean} isMasterCi - TRUE if the CI run is on master; FALSE if PR or not CI run
 * @property {string} projectLanguage - The language used in the project. Can be either TS or JS.
 * @property {number} totalCssBundleSize - The total size of all CSS files in KBs (GZIP)
 * @property {number} yoshiMajorVersion - The major version of Yoshi used in the project.
 * @property {number} totalImagesBundleSize - The total size of all image files in KBs (GZIP)
 * @property {number} totalClientBundleSize - The total size of the minified bundle in KBs (GZIP)
 * @property {number} totalJsBundleSize - The total size of all JS files in KBs (GZIP)
 * @property {string} yoshiFlow - Should return a string with the used yoshi flow (e.g. yoshi-flow-editor))
 * @property {string} yoshiVersion - The semver version of Yoshi used in the project.
 * @property {string} typescriptVersion - The typescript version used in the project.
 * @return {LogObject<buildEndParams>} LogObject<buildEndParams>
 */
export function buildEnd(params: buildEndParams): LogObject<buildEndParams> {
  return { evid: 91403, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'yoshiYarnStartFinished' event (evid: 91405)
 *
 * Event description: Sent when Yoshi is ready to load the page after the user types the "yarn start" command
 *
 * @param {yoshiYarnStartFinishedParams} params - The parameters for this event
 * @property {boolean} isCI - Should be true if was fired from a CI environment
 * @property {number} duration - The time it took from the "yarn start" command (event 91404) to Yoshi's readiness to load the page (in ms)
 * @property {string} projectName - The name of the project (name in package.json).
 * @property {number} nodeMajorVersion - The major version of Node used in the project.
 * @property {string} email - User email
 * @property {boolean} isMasterCi - TRUE if the CI run is on master; FALSE if PR or not CI run
 * @property {string} projectLanguage - The language used in the project. Can be either TS or JS.
 * @property {number} yoshiMajorVersion - yoshi_major_version
 * @property {string} yoshiFlow - Should return a string with the used yoshi flow (e.g. yoshi-flow-editor))
 * @property {string} yoshiVersion - The semver version of Yoshi used in the project.
 * @property {string} typescriptVersion - typescript_version
 * @return {LogObject<yoshiYarnStartFinishedParams>} LogObject<yoshiYarnStartFinishedParams>
 */
export function yoshiYarnStartFinished(params: yoshiYarnStartFinishedParams): LogObject<yoshiYarnStartFinishedParams> {
  return { evid: 91405, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'yoshiTestsRunStart' event (evid: 91406)
 *
 * Event description: Sent when Yoshi starts running tests for a specific project
 *
 * @param {yoshiTestsRunStartParams} params - The parameters for this event
 * @property {boolean} isCI - Should be true if was fired from a CI environment
 * @property {string} projectName - The name of the project (name in package.json).
 * @property {number} nodeMajorVersion - The major version of Node used in the project.
 * @property {number} numTests - Number of tests Yoshi is running
 * @property {string} email - User email
 * @property {boolean} isMasterCi - TRUE if the CI run is on master; FALSE if PR or not CI run
 * @property {string} projectLanguage - The language used in the project. Can be either TS or JS.
 * @property {number} yoshiMajorVersion - The major version of Yoshi used in the project.
 * @property {string} yoshiFlow - Should return a string with the used yoshi flow (e.g. yoshi-flow-editor))
 * @property {string} yoshiVersion - The semver version of Yoshi used in the project.
 * @property {string} typescriptVersion - The typescript version used in the project.
 * @return {LogObject<yoshiTestsRunStartParams>} LogObject<yoshiTestsRunStartParams>
 */
export function yoshiTestsRunStart(params: yoshiTestsRunStartParams): LogObject<yoshiTestsRunStartParams> {
  return { evid: 91406, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'yoshiTestsRunEnd' event (evid: 91407)
 *
 * Event description: Sent when Yoshi is done running tests for a specific project
 *
 * @param {yoshiTestsRunEndParams} params - The parameters for this event
 * @property {boolean} isCI - Should be true if was fired from a CI environment
 * @property {number} duration - Time it took to run all tests (in ms)
 * @property {string} projectName - The name of the project (name in package.json).
 * @property {number} nodeMajorVersion - The major version of Node used in the project.
 * @property {number} numTests - Number of tests Yoshi is running
 * @property {string} email - User email
 * @property {string} result - Was the run successful or not
 * @property {boolean} isMasterCi - TRUE if the CI run is on master; FALSE if PR or not CI run
 * @property {string} projectLanguage - The language used in the project. Can be either TS or JS.
 * @property {number} yoshiMajorVersion - The major version of Yoshi used in the project.
 * @property {string} yoshiFlow - Should return a string with the used yoshi flow (e.g. yoshi-flow-editor))
 * @property {string} yoshiVersion - The semver version of Yoshi used in the project.
 * @property {string} typescriptVersion - The typescript version used in the project.
 * @return {LogObject<yoshiTestsRunEndParams>} LogObject<yoshiTestsRunEndParams>
 */
export function yoshiTestsRunEnd(params: yoshiTestsRunEndParams): LogObject<yoshiTestsRunEndParams> {
  return { evid: 91407, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'yoshiCodeChangeDetected' event (evid: 91408)
 *
 * Event description: Sent when Yoshi detects the user has changed code in the project
 *
 * @param {yoshiCodeChangeDetectedParams} params - The parameters for this event
 * @property {boolean} isCI - Should be true if was fired from a CI environment
 * @property {string} projectName - The name of the project (name in package.json).
 * @property {number} nodeMajorVersion - The major version of Node used in the project.
 * @property {string} email - User email
 * @property {string} compilationType - Did the user change the client, server, or Yoshi server code
 * @property {boolean} isMasterCi - TRUE if the CI run is on master; FALSE if PR or not CI run
 * @property {string} projectLanguage - The language used in the project. Can be either TS or JS.
 * @property {number} yoshiMajorVersion - The major version of Yoshi used in the project.
 * @property {string} yoshiFlow - Should return a string with the used yoshi flow (e.g. yoshi-flow-editor))
 * @property {string} yoshiVersion - The semver version of Yoshi used in the project.
 * @property {string} typescriptVersion - The typescript version used in the project.
 * @return {LogObject<yoshiCodeChangeDetectedParams>} LogObject<yoshiCodeChangeDetectedParams>
 */
export function yoshiCodeChangeDetected(params: yoshiCodeChangeDetectedParams): LogObject<yoshiCodeChangeDetectedParams> {
  return { evid: 91408, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'yoshiReadyForReloadAfterCodeChange' event (evid: 91409)
 *
 * Event description: Sent when Yoshi is ready to reload the page after it has detected the user has changed code in the project
 *
 * @param {yoshiReadyForReloadAfterCodeChangeParams} params - The parameters for this event
 * @property {boolean} isCI - is_ciboo
 * @property {number} duration - Time it took for Yoshi to be ready to load the page after the code change (in ms)
 * @property {string} projectName - The name of the project (name in package.json).
 * @property {number} nodeMajorVersion - The major version of Node used in the project.
 * @property {string} email - User email
 * @property {string} compilationType - Did the user change the client, server, or Yoshi server code
 * @property {boolean} isMasterCi - TRUE if the CI run is on master; FALSE if PR or not CI run
 * @property {string} projectLanguage - The language used in the project. Can be either TS or JS.
 * @property {number} yoshiMajorVersion - The major version of Yoshi used in the project.
 * @property {string} yoshiFlow - Should return a string with the used yoshi flow (e.g. yoshi-flow-editor))
 * @property {string} yoshiVersion - The semver version of Yoshi used in the project.
 * @property {string} typescriptVersion - The typescript version used in the project.
 * @return {LogObject<yoshiReadyForReloadAfterCodeChangeParams>} LogObject<yoshiReadyForReloadAfterCodeChangeParams>
 */
export function yoshiReadyForReloadAfterCodeChange(params: yoshiReadyForReloadAfterCodeChangeParams): LogObject<yoshiReadyForReloadAfterCodeChangeParams> {
  return { evid: 91409, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'perferTestResult' event (evid: 91501)
 *
 * Event description: Sent for every test in Perfer Bundle or in Lightouse (total download size)
 *
 * @param {perferTestResultParams} params - The parameters for this event
 * @property {string} artifactId - The artifact id
 * @property {string} testName - The test name (can be null if Perfer bundles)
 * @property {string} fingerprint - The fignretprint
 * @property {string} result - The tests result could be fail or pass (for Perfer bundle will be fail if at least 1 bundle failed 1 metric)
 * @property {string} branch - The branch name
 * @property {string} fileName - The file name  (can be null if Perfer bundles)
 * @property {string} type - The type of test, can be Perfer bundle or Total Download Size
 * @property {string} runId - The run id
 * @return {LogObject<perferTestResultParams>} LogObject<perferTestResultParams>
 */
export function perferTestResult(params: perferTestResultParams): LogObject<perferTestResultParams> {
  return { evid: 91501, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'perferBundleResult' event (evid: 91502)
 *
 * Event description: Sent for every bundle result in Perfer
 *
 * @param {perferBundleResultParams} params - The parameters for this event
 * @property {string} artifactId - The artifact id
 * @property {string} testName - The test name (will be null if Perfer bundle test)
 * @property {string} fingerprint - The fingerprint
 * @property {string} bundle - The bundle name
 * @property {string} size - The actual bundle size in byte
 * @property {number} absoluteLimit - The absolute limit for the bundle (in byte), can be null if no limit specified
 * @property {string} result - The result (pass/fail)
 * @property {string} branch - The branch name
 * @property {string} fileName - The file name (will be null if Perfer bundle)
 * @property {number} relativeLimit - The relative limit for the bundle (in percentage between 0-100), can be null if no limit specified
 * @property {string} testId - The test id
 * @property {string} type - TDS or Perfer Bundle
 * @property {string} baselineValue - The baseline size in byte
 * @return {LogObject<perferBundleResultParams>} LogObject<perferBundleResultParams>
 */
export function perferBundleResult(params: perferBundleResultParams): LogObject<perferBundleResultParams> {
  return { evid: 91502, src: 11, endpoint: '', params };
}

/**
 * A function to create a log object for the 'devibeUserClickSrc196Evid10' event (evid: 10)
 *
 * Event description: a generic event for click by user in any page/modal/panel
 *
 * @param {devibeUserClickSrc196Evid10Params} params - The parameters for this event
 * @property {string} Product_Area - the area of the page in Devibe funnel:  Onboarding/Planner/Workspace
 * @property {string} Page_name - the name of the current page (In workspace - will be the current tab- code/dashboard/preview)
 * @property {GUID} Page_id - a unique id for each page
 * @property {string} Page_area - Relevant if the button is in s specific area of the page (Page Header, Chat sidebar, Certain modal..)
 * @property {string} Button_name - the actual name of the button/CTA
 * @property {string} Value - relevant when there are several options within/after a button click, like expanded dropdown.
 * @property {string} Last_value - Previous value before the current click
 * @property {GUID} Conversation_id - A unique identifier of the project (app). Same ID that sent from the BI of AI Assistant (src 171).  Will be used to connect between our events and src 171 events
 * @property {GUID} Devibe_session_id - Consistent over one session - from onboarding to workspace. Session ends when closing the browser
 * @property {GUID} app_id - Devibe app id
 * @property {string} First_prompt - Relevant when the button name is the initial 'Build' click from the onboarding page
 * @property {string} Widget_name - Relevant when the click is in a specific chat widget
 * @return {LogObject<devibeUserClickSrc196Evid10Params>} LogObject<devibeUserClickSrc196Evid10Params>
 */
export function devibeUserClickSrc196Evid10(params: devibeUserClickSrc196Evid10Params): LogObject<devibeUserClickSrc196Evid10Params> {
  return { evid: 10, src: 196, endpoint: '', params };
}

/**
 * A function to create a log object for the 'devibeLandedOnWorksapceSrc196Evid13' event (evid: 13)
 *
 * Event description: User landed on workspace area 
 *
 * @param {devibeLandedOnWorksapceSrc196Evid13Params} params - The parameters for this event
 * @property {string} Product_Area - the area of the page in Devibe funnel:  Onboarding/Planner/Workspace
 * @property {string} Page_name - the name of the tab that just loaded on the workspace
 * @property {GUID} Page_id - a unique id for each page
 * @property {string} URL - the url of the page
 * @property {string} Referal_url - the url of the page that led to to current page  (if opened by saved link will be null)
 * @property {string} Referal_info - the specific button that led to landing on workspace (e.g 'build it' from blueprint)
 * @property {number} Window_width - Window_width
 * @property {number} Window_height - Window_height
 * @property {number} Screen_width - Screen_width
 * @property {number} Screen_height - Screen_height
 * @property {GUID} Conversation_id - A unique identifier of the project (app). Same ID that sent from the BI of AI Assistant (src 171).  Will be used to connect between our events and src 171 events
 * @property {GUID} Devibe_session_id - Should be consistent over one session - from onboarding to workspace. Session ends when closing the browser
 * @property {GUID} app_id - Devibe app id
 * @return {LogObject<devibeLandedOnWorksapceSrc196Evid13Params>} LogObject<devibeLandedOnWorksapceSrc196Evid13Params>
 */
export function devibeLandedOnWorksapceSrc196Evid13(params: devibeLandedOnWorksapceSrc196Evid13Params): LogObject<devibeLandedOnWorksapceSrc196Evid13Params> {
  return { evid: 13, src: 196, endpoint: '', params };
}

/**
 * A function to create a log object for the 'devibeErrorPageShownSrc196Evid15' event (evid: 15)
 *
 * Event description: Error page shown (for specific errors)
 *
 * @param {devibeErrorPageShownSrc196Evid15Params} params - The parameters for this event
 * @property {string} Product_Area - the area of the page in Devibe funnel:  Onboarding/Planner/Workspace
 * @property {string} Page_name - the name of the current page (In workspace - will be the current tab- code/dashboard/preview)
 * @property {GUID} Page_id - a unique id for each page
 * @property {string} Page_area - Relevant if the error is in s specific area of the page (Page Header, Chat sidebar, Certain modal..)
 * @property {GUID} Conversation_id - A unique identifier of the project (app). Same ID that sent from the BI of AI Assistant (src 171).  Will be used to connect between our events and src 171 events
 * @property {GUID} Devibe_session_id - Consistent over one session - from onboarding to workspace. Session ends when closing the browser
 * @property {string} Error_message - Error message as presented in the UI
 * @property {string} Error_desc - error description
 * @property {GUID} app_id - Devibe app id
 * @property {string} Request_id - Request id of the error
 * @property {string} button_names - list of available buttons presented to the user
 * @return {LogObject<devibeErrorPageShownSrc196Evid15Params>} LogObject<devibeErrorPageShownSrc196Evid15Params>
 */
export function devibeErrorPageShownSrc196Evid15(params: devibeErrorPageShownSrc196Evid15Params): LogObject<devibeErrorPageShownSrc196Evid15Params> {
  return { evid: 15, src: 196, endpoint: '', params };
}

/**
 * A function to create a log object for the 'devibePageStartLoadingSrc196Evid2' event (evid: 2)
 *
 * Event description: a generic event for Devibe pages loading
 *
 * @param {devibePageStartLoadingSrc196Evid2Params} params - The parameters for this event
 * @property {string} Product_Area - the area of the page in Devibe funnel:  Onboarding/Planner/Workspace
 * @property {string} Page_name - the name of the page that started loading
 * @property {GUID} Page_id - a unique id for each page
 * @property {string} URL - the url of the page
 * @property {string} Referal_url - the url of the page that led to to current page load (if opened by saved link will be null)
 * @property {string} Referal_info - the specific button that triggered the page load (if opened by saved link will be null)
 * @property {number} Window_width - Window_width
 * @property {number} Window_height - Window_height
 * @property {number} Screen_width - Screen_width
 * @property {number} Screen_height - Screen_height
 * @property {GUID} Conversation_id - A unique identifier of the project (app). Same ID that sent from the BI of AI Assistant (src 171).  Will be used to connect between our events and src 171 events
 * @property {GUID} Devibe_session_id - Should be consistent over one session - from onboarding to workspace. Session ends when closing the browser
 * @property {GUID} app_id - Devibe app id
 * @return {LogObject<devibePageStartLoadingSrc196Evid2Params>} LogObject<devibePageStartLoadingSrc196Evid2Params>
 */
export function devibePageStartLoadingSrc196Evid2(params: devibePageStartLoadingSrc196Evid2Params): LogObject<devibePageStartLoadingSrc196Evid2Params> {
  return { evid: 2, src: 196, endpoint: '', params };
}

/**
 * A function to create a log object for the 'devibeCodegenAgentSessionStartSrc196Evid200' event (evid: 200)
 *
 * Event description: Agent session started in Codegen
 *
 *
 *
 *
 *
 * @param {devibeCodegenAgentSessionStartSrc196Evid200Params} params - The parameters for this event
 * @property {string} Task_id - The agent task ID is unique for each task within a job. It’s used to link together the start, end, and error events for that specific run.
 * @property {string} Extra_data - additional run data
 * @property {number} Task_cost - The cost of the current task
 * @property {GUID} Devibe_session_id - Should be consistent over one session - from onboarding to workspace. Session ends when closing the browser
 * @property {GUID} Job_id - job ID is unique for each user-prompt. (within one job - a few tasks are running)
 * @property {number} Job_cost - The cost of the current job
 * @property {GUID} app_id - Devibe app id
 * @property {string} run_kind - Initial / Iterate / blueprint
 * @property {string} Task_model - The AI model that works on the task
 * @property {string} Task_type - Fix / Parent / Type of extension
 * @property {string} job_input - the user prompt that initiated the codegen process (will be sent on the Parent task)
 * @return {LogObject<devibeCodegenAgentSessionStartSrc196Evid200Params>} LogObject<devibeCodegenAgentSessionStartSrc196Evid200Params>
 */
export function devibeCodegenAgentSessionStartSrc196Evid200(params: devibeCodegenAgentSessionStartSrc196Evid200Params): LogObject<devibeCodegenAgentSessionStartSrc196Evid200Params> {
  return { evid: 200, src: 196, endpoint: '', params };
}

/**
 * A function to create a log object for the 'devibeCodegenAgentSessionEndSrc196Evid201' event (evid: 201)
 *
 * Event description: Agent session ended in Codegen
 *
 *
 *
 *
 *
 * @param {devibeCodegenAgentSessionEndSrc196Evid201Params} params - The parameters for this event
 * @property {string} Task_id - The agent task ID is unique for each task within a job. It’s used to link together the start, end, and error events for that specific run.
 * @property {string} Extra_data - additional run data
 * @property {number} Task_cost - The cost of the current task
 * @property {GUID} Devibe_session_id - Should be consistent over one session - from onboarding to workspace. Session ends when closing the browser
 * @property {string} Agent_output - the output for the agent - list of changed files. Per changed file:
 * { Path (relative path of the file within the app,
 * Content (all the code that the agent wrote for that file),
 * Operation (create/updated),
 * Output text (what the users sees in the chat) }
 * @property {GUID} Job_id - job ID is unique for each user-prompt. (within one job - a few tasks are running)
 * @property {string} Task_status - ‘Stopped’ if the user clicked on stop button, ‘error’, or ‘successfull’
 * @property {number} Job_cost - The cost of the current job
 * @property {GUID} app_id - Devibe app id
 * @property {string} run_kind - Initial / iterate / blueprint
 * @property {string} Task_type - Fix / Parent / Type of extension
 * @property {string} Task_model - The AI model that works on the task
 *
 * @property {string} job_input - the user prompt that initiated the codegen process (will be sent on the Parent task)
 * @return {LogObject<devibeCodegenAgentSessionEndSrc196Evid201Params>} LogObject<devibeCodegenAgentSessionEndSrc196Evid201Params>
 */
export function devibeCodegenAgentSessionEndSrc196Evid201(params: devibeCodegenAgentSessionEndSrc196Evid201Params): LogObject<devibeCodegenAgentSessionEndSrc196Evid201Params> {
  return { evid: 201, src: 196, endpoint: '', params };
}

/**
 * A function to create a log object for the 'devibeCodegenAgentSessionErrorSrc196Evid202' event (evid: 202)
 *
 * Event description: Agent session ended in Codegen
 *
 *
 *
 *
 *
 * @param {devibeCodegenAgentSessionErrorSrc196Evid202Params} params - The parameters for this event
 * @property {string} Task_id - The agent task ID is unique for each task within a job. It’s used to link together the start, end, and error events for that specific run.
 * @property {string} Extra_data - additional run data
 * @property {GUID} Devibe_session_id - Should be consistent over one session - from onboarding to workspace. Session ends when closing the browser
 * @property {string} Agent_output - the output for the agent - the error object
 * @property {string} Error_desc - Description of the error - the unique identifier of the error
 * @property {GUID} Job_id - job ID is unique for each user-prompt. (within one job - a few tasks are running)
 * @property {GUID} app_id - Devibe app id
 * @property {string} run_kind - Initial / Iterate / blueprint
 * @property {string} task_type - Fix / Parent / Type of extension
 *
 * @property {string} task_model - The AI model that works on the task
 *
 * @property {string} error_massage - error description from the system
 * @property {string} error_json - full errors details
 * @property {boolean} is_retryable - is try again presented True/false
 * @property {boolean} is_expected - is expected error
 * @property {string} validation_type - relevant for validation errors only: typescript error/ build error validation/ dev center validation
 * @return {LogObject<devibeCodegenAgentSessionErrorSrc196Evid202Params>} LogObject<devibeCodegenAgentSessionErrorSrc196Evid202Params>
 */
export function devibeCodegenAgentSessionErrorSrc196Evid202(params: devibeCodegenAgentSessionErrorSrc196Evid202Params): LogObject<devibeCodegenAgentSessionErrorSrc196Evid202Params> {
  return { evid: 202, src: 196, endpoint: '', params };
}

/**
 * A function to create a log object for the 'devibePageFinishLoadingSrc196Evid3' event (evid: 3)
 *
 * Event description: a generic event for Devibe pages loading
 *
 * @param {devibePageFinishLoadingSrc196Evid3Params} params - The parameters for this event
 * @property {string} Product_Area - the area of the page in Devibe funnel:  Onboarding/Planner/Workspace
 * @property {string} Page_name - the name of the page that started loading
 * @property {GUID} Page_id - a unique id for each page
 * @property {string} URL - the url of the page
 * @property {string} Referal_url - the url of the page that led to to current page load (if opened by saved link will be null)
 * @property {string} Referal_info - the specific button that triggered the page load (if opened by saved link will be null)
 * @property {number} Window_width - Window_width
 * @property {number} Window_height - Window_height
 * @property {number} Screen_width - Screen_width
 * @property {number} Screen_height - Screen_height
 * @property {GUID} Conversation_id - A unique identifier of the project (app). Same ID that sent from the BI of AI Assistant (src 171).  Will be used to connect between our events and src 171 events
 * @property {GUID} Devibe_session_id - Should be consistent over one session - from onboarding to workspace. Session ends when closing the browser
 * @property {number} Loading_time - time in milliseconds between start load and finish load
 * @property {GUID} app_id - Devibe app id
 * @return {LogObject<devibePageFinishLoadingSrc196Evid3Params>} LogObject<devibePageFinishLoadingSrc196Evid3Params>
 */
export function devibePageFinishLoadingSrc196Evid3(params: devibePageFinishLoadingSrc196Evid3Params): LogObject<devibePageFinishLoadingSrc196Evid3Params> {
  return { evid: 3, src: 196, endpoint: '', params };
}

/**
 * A function to create a log object for the 'devibeBlueprintVersionReadySrc196Evid4' event (evid: 4)
 *
 * Event description: Devibe planner stage - blueprint is ready
 *
 * @param {devibeBlueprintVersionReadySrc196Evid4Params} params - The parameters for this event
 * @property {string} Product_Area - the area of the page in Devibe funnel:  Onboarding/Planner/Workspace
 * @property {string} Page_name - the name of the page that started loading
 * @property {GUID} Page_id - a unique id for each page
 * @property {GUID} Conversation_id - A unique identifier of the project (app). Same ID that sent from the BI of AI Assistant (src 171).  Will be used to connect between our events and src 171 events
 * @property {GUID} Devibe_session_id - Should be consistent over one session - from onboarding to workspace. Session ends when closing the browser
 * @property {string} Version_number - the number of the current version (as appears on top of the blueprint UI)
 * @property {string} Created_by - is the current version created by User-prompt / Manual feature editing / version restoration
 * @property {boolean} Is_restored - True if this version created by restoring to a previous version
 * @property {string} App_name - The name of the app according to the version
 * @property {string} Key_features - List of key features in the version
 * @property {GUID} app_id - Devibe app id
 * @return {LogObject<devibeBlueprintVersionReadySrc196Evid4Params>} LogObject<devibeBlueprintVersionReadySrc196Evid4Params>
 */
export function devibeBlueprintVersionReadySrc196Evid4(params: devibeBlueprintVersionReadySrc196Evid4Params): LogObject<devibeBlueprintVersionReadySrc196Evid4Params> {
  return { evid: 4, src: 196, endpoint: '', params };
}

/**
 * A function to create a log object for the 'devibeErrorSrc196Evid5' event (evid: 5)
 *
 * Event description: An error occurred
 *
 * @param {devibeErrorSrc196Evid5Params} params - The parameters for this event
 * @property {string} Product_Area - the area of the page in Devibe funnel:  Onboarding/Planner/Workspace
 * @property {string} Page_name - the name of the current page (In workspace - will be the current tab- code/dashboard/preview)
 * @property {GUID} Page_id - a unique id for each page
 * @property {string} Page_area - Relevant if the error is in s specific area of the page (Page Header, Chat sidebar, Certain modal..)
 * @property {GUID} Conversation_id - A unique identifier of the project (app). Same ID that sent from the BI of AI Assistant (src 171).  Will be used to connect between our events and src 171 events
 * @property {GUID} Devibe_session_id - Consistent over one session - from onboarding to workspace. Session ends when closing the browser
 * @property {string} Error_message - Error message as presented in the UI
 * @property {string} Error_desc - error description
 * @property {number} Error_code - error code
 * @property {string} Error_type - System/user
 * @property {string} Error_source - the user action that triggered the error (e.g manual code edit)
 * @property {boolean} Try_again_presented - is the 'try again' button presented to the user
 * @property {GUID} app_id - Devibe app id
 * @property {string} Request_id - Request id of the error
 * @return {LogObject<devibeErrorSrc196Evid5Params>} LogObject<devibeErrorSrc196Evid5Params>
 */
export function devibeErrorSrc196Evid5(params: devibeErrorSrc196Evid5Params): LogObject<devibeErrorSrc196Evid5Params> {
  return { evid: 5, src: 196, endpoint: '', params };
}

/**
 * A function to create a log object for the 'devibeAppCheckpointCreatedSrc196Evid6' event (evid: 6)
 *
 * Event description: Devibe Workspace - App Checkpoint created in AI sidebar
 *
 * @param {devibeAppCheckpointCreatedSrc196Evid6Params} params - The parameters for this event
 * @property {string} Product_Area - the area of the page in Devibe funnel:  Onboarding/Planner/Workspace
 * @property {string} Page_name - the name of the current page (In workspace - will be the current tab- code/dashboard/preview)
 * @property {GUID} Page_id - a unique id for each page
 * @property {GUID} Conversation_id - A unique identifier of the project (app). Same ID that sent from the BI of AI Assistant (src 171).  Will be used to connect between our events and src 171 events
 * @property {GUID} Devibe_session_id - Consistent over one session - from onboarding to workspace. Session ends when closing the browser
 * @property {GUID} Job_id - The id of the job that led to this checkpoint creation
 * @property {string} Checkpoint_title - as it appears in the UI (e.g ‘Widget made responsive’)
 * @property {string} extra_data - extra_data
 * @property {GUID} app_id - Devibe app id
 * @property {GUID} Checkpoint_id - A unique identifier of the version 
 * @property {DateTime} checkpoint_ts - timestamp of the version creation
 * @return {LogObject<devibeAppCheckpointCreatedSrc196Evid6Params>} LogObject<devibeAppCheckpointCreatedSrc196Evid6Params>
 */
export function devibeAppCheckpointCreatedSrc196Evid6(params: devibeAppCheckpointCreatedSrc196Evid6Params): LogObject<devibeAppCheckpointCreatedSrc196Evid6Params> {
  return { evid: 6, src: 196, endpoint: '', params };
}

/**
 * A function to create a log object for the 'devibeEarlierAppCheckpointActionCompletedSrc196Evid7' event (evid: 7)
 *
 * Event description: Devibe Workspace - action on a previous app checkpoint
 *
 * @param {devibeEarlierAppCheckpointActionCompletedSrc196Evid7Params} params - The parameters for this event
 * @property {string} Product_Area - the area of the page in Devibe funnel:  Onboarding/Planner/Workspace
 * @property {string} Page_name - the name of the current page (In workspace - will be the current tab- code/dashboard/preview)
 * @property {GUID} Page_id - a unique id for each page
 * @property {GUID} Conversation_id - A unique identifier of the project (app). Same ID that sent from the BI of AI Assistant (src 171).  Will be used to connect between our events and src 171 events
 * @property {GUID} Devibe_session_id - Consistent over one session - from onboarding to workspace. Session ends when closing the browser
 * @property {string} extra_data - extra_data
 * @property {string} Action - Restore / Preview Dashboard / Preview Site
 * @property {GUID} app_id - Devibe app id
 * @property {GUID} Checkpoint_id_after - The id of the version after the restore/undo action
 * @property {GUID} Checkpoint_id_before - The id of the version before the restore/undo action
 * @return {LogObject<devibeEarlierAppCheckpointActionCompletedSrc196Evid7Params>} LogObject<devibeEarlierAppCheckpointActionCompletedSrc196Evid7Params>
 */
export function devibeEarlierAppCheckpointActionCompletedSrc196Evid7(params: devibeEarlierAppCheckpointActionCompletedSrc196Evid7Params): LogObject<devibeEarlierAppCheckpointActionCompletedSrc196Evid7Params> {
  return { evid: 7, src: 196, endpoint: '', params };
}

/**
 * A function to create a log object for the 'devibeChatWidgetLoadedSrc196Evid8' event (evid: 8)
 *
 * Event description: A widget was loaded in the chat
 *
 * @param {devibeChatWidgetLoadedSrc196Evid8Params} params - The parameters for this event
 * @property {string} Product_Area - the area of the page in Devibe funnel:  Onboarding/Planner/Workspace
 * @property {string} Page_name - the name of the current page (In workspace - will be the current tab- code/dashboard/preview)
 * @property {GUID} Page_id - a unique id for each page
 * @property {string} Page_area - Relevant if the button is in s specific area of the page (Page Header, Chat sidebar, Certain modal..)
 * @property {GUID} Conversation_id - A unique identifier of the project (app). Same ID that sent from the BI of AI Assistant (src 171).  Will be used to connect between our events and src 171 events
 * @property {GUID} Devibe_session_id - Consistent over one session - from onboarding to workspace. Session ends when closing the browser
 * @property {GUID} app_id - Devibe app id
 * @property {string} Widget_name - A name that uniquely identifies this kind of widget
 * @property {GUID} Widget_id - An id that identifies a specific instance of the widget
 * @return {LogObject<devibeChatWidgetLoadedSrc196Evid8Params>} LogObject<devibeChatWidgetLoadedSrc196Evid8Params>
 */
export function devibeChatWidgetLoadedSrc196Evid8(params: devibeChatWidgetLoadedSrc196Evid8Params): LogObject<devibeChatWidgetLoadedSrc196Evid8Params> {
  return { evid: 8, src: 196, endpoint: '', params };
}

/**
 * A function to create a log object for the 'chatGptWixAppActionSrc39Evid1609' event (evid: 1609)
 *
 * Event description: Wix App Action
 *
 * @param {chatGptWixAppActionSrc39Evid1609Params} params - The parameters for this event
 * @property {string} actionName - the action name (edit site/view site/full_screen)
 * @property {string} msid - the msid 
 * @property {string} uuid - the user id
 * @property {string} type - type
 * @property {string} asset_id - asset_id
 * @property {string} asset_class - asset_class
 * @property {string} project_id - project_id
 * @return {LogObject<chatGptWixAppActionSrc39Evid1609Params>} LogObject<chatGptWixAppActionSrc39Evid1609Params>
 */
export function chatGptWixAppActionSrc39Evid1609(params: chatGptWixAppActionSrc39Evid1609Params): LogObject<chatGptWixAppActionSrc39Evid1609Params> {
  return { evid: 1609, src: 39, endpoint: '', params };
}

/**
 * A function to create a log object for the 'dpKbMcpServerCallSrc39Evid1996' event (evid: 1996)
 *
 * Event description: DP KB MCP Server Call 
 *
 * @param {dpKbMcpServerCallSrc39Evid1996Params} params - The parameters for this event
 * @property {string} mcp_query - mcp query
 * @return {LogObject<dpKbMcpServerCallSrc39Evid1996Params>} LogObject<dpKbMcpServerCallSrc39Evid1996Params>
 */
export function dpKbMcpServerCallSrc39Evid1996(params: dpKbMcpServerCallSrc39Evid1996Params): LogObject<dpKbMcpServerCallSrc39Evid1996Params> {
  return { evid: 1996, src: 39, endpoint: '', params };
}
